import re, { forwardRef as Yo, useEffect as Ht, useReducer as Xo, useState as gt, useRef as _e, isValidElement as Xt, cloneElement as tr, useLayoutEffect as Ko } from "react";
import { connect as Qo, useSelector as Ar } from "react-redux";
import { combineReducers as _o } from "redux";
import { useNavigate as $r } from "react-router-dom";
var xt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, nr = { exports: {} }, en = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wr;
function $o() {
  if (wr)
    return en;
  wr = 1;
  var e = re, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var d, f = {}, R = null, p = null;
    c !== void 0 && (R = "" + c), l.key !== void 0 && (R = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (d in l)
      r.call(l, d) && !i.hasOwnProperty(d) && (f[d] = l[d]);
    if (s && s.defaultProps)
      for (d in l = s.defaultProps, l)
        f[d] === void 0 && (f[d] = l[d]);
    return { $$typeof: t, type: s, key: R, ref: p, props: f, _owner: o.current };
  }
  return en.Fragment = n, en.jsx = a, en.jsxs = a, en;
}
var tn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var br;
function ei() {
  return br || (br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = re, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, g = "@@iterator";
    function v(u) {
      if (u === null || typeof u != "object")
        return null;
      var y = h && u[h] || u[g];
      return typeof y == "function" ? y : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(u) {
      {
        for (var y = arguments.length, L = new Array(y > 1 ? y - 1 : 0), z = 1; z < y; z++)
          L[z - 1] = arguments[z];
        D("error", u, L);
      }
    }
    function D(u, y, L) {
      {
        var z = E.ReactDebugCurrentFrame, oe = z.getStackAddendum();
        oe !== "" && (y += "%s", L = L.concat([oe]));
        var ue = L.map(function(_) {
          return String(_);
        });
        ue.unshift("Warning: " + y), Function.prototype.apply.call(console[u], console, ue);
      }
    }
    var B = !1, U = !1, $ = !1, se = !1, H = !1, de;
    de = Symbol.for("react.module.reference");
    function Y(u) {
      return !!(typeof u == "string" || typeof u == "function" || u === r || u === i || H || u === o || u === c || u === d || se || u === p || B || U || $ || typeof u == "object" && u !== null && (u.$$typeof === R || u.$$typeof === f || u.$$typeof === a || u.$$typeof === s || u.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      u.$$typeof === de || u.getModuleId !== void 0));
    }
    function G(u, y, L) {
      var z = u.displayName;
      if (z)
        return z;
      var oe = y.displayName || y.name || "";
      return oe !== "" ? L + "(" + oe + ")" : L;
    }
    function J(u) {
      return u.displayName || "Context";
    }
    function te(u) {
      if (u == null)
        return null;
      if (typeof u.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof u == "function")
        return u.displayName || u.name || null;
      if (typeof u == "string")
        return u;
      switch (u) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case s:
            var y = u;
            return J(y) + ".Consumer";
          case a:
            var L = u;
            return J(L._context) + ".Provider";
          case l:
            return G(u, u.render, "ForwardRef");
          case f:
            var z = u.displayName || null;
            return z !== null ? z : te(u.type) || "Memo";
          case R: {
            var oe = u, ue = oe._payload, _ = oe._init;
            try {
              return te(_(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, b = 0, I, O, A, x, P, M, ce;
    function he() {
    }
    he.__reactDisabledLog = !0;
    function Ie() {
      {
        if (b === 0) {
          I = console.log, O = console.info, A = console.warn, x = console.error, P = console.group, M = console.groupCollapsed, ce = console.groupEnd;
          var u = {
            configurable: !0,
            enumerable: !0,
            value: he,
            writable: !0
          };
          Object.defineProperties(console, {
            info: u,
            log: u,
            warn: u,
            error: u,
            group: u,
            groupCollapsed: u,
            groupEnd: u
          });
        }
        b++;
      }
    }
    function Pe() {
      {
        if (b--, b === 0) {
          var u = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, u, {
              value: I
            }),
            info: N({}, u, {
              value: O
            }),
            warn: N({}, u, {
              value: A
            }),
            error: N({}, u, {
              value: x
            }),
            group: N({}, u, {
              value: P
            }),
            groupCollapsed: N({}, u, {
              value: M
            }),
            groupEnd: N({}, u, {
              value: ce
            })
          });
        }
        b < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ve = E.ReactCurrentDispatcher, We;
    function Fe(u, y, L) {
      {
        if (We === void 0)
          try {
            throw Error();
          } catch (oe) {
            var z = oe.stack.trim().match(/\n( *(at )?)/);
            We = z && z[1] || "";
          }
        return `
` + We + u;
      }
    }
    var He = !1, le;
    {
      var Ee = typeof WeakMap == "function" ? WeakMap : Map;
      le = new Ee();
    }
    function at(u, y) {
      if (!u || He)
        return "";
      {
        var L = le.get(u);
        if (L !== void 0)
          return L;
      }
      var z;
      He = !0;
      var oe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = Ve.current, Ve.current = null, Ie();
      try {
        if (y) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (dt) {
              z = dt;
            }
            Reflect.construct(u, [], _);
          } else {
            try {
              _.call();
            } catch (dt) {
              z = dt;
            }
            u.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (dt) {
            z = dt;
          }
          u();
        }
      } catch (dt) {
        if (dt && z && typeof dt.stack == "string") {
          for (var Q = dt.stack.split(`
`), Je = z.stack.split(`
`), Re = Q.length - 1, ye = Je.length - 1; Re >= 1 && ye >= 0 && Q[Re] !== Je[ye]; )
            ye--;
          for (; Re >= 1 && ye >= 0; Re--, ye--)
            if (Q[Re] !== Je[ye]) {
              if (Re !== 1 || ye !== 1)
                do
                  if (Re--, ye--, ye < 0 || Q[Re] !== Je[ye]) {
                    var Ye = `
` + Q[Re].replace(" at new ", " at ");
                    return u.displayName && Ye.includes("<anonymous>") && (Ye = Ye.replace("<anonymous>", u.displayName)), typeof u == "function" && le.set(u, Ye), Ye;
                  }
                while (Re >= 1 && ye >= 0);
              break;
            }
        }
      } finally {
        He = !1, Ve.current = ue, Pe(), Error.prepareStackTrace = oe;
      }
      var zt = u ? u.displayName || u.name : "", yr = zt ? Fe(zt) : "";
      return typeof u == "function" && le.set(u, yr), yr;
    }
    function Et(u, y, L) {
      return at(u, !1);
    }
    function Wn(u) {
      var y = u.prototype;
      return !!(y && y.isReactComponent);
    }
    function kt(u, y, L) {
      if (u == null)
        return "";
      if (typeof u == "function")
        return at(u, Wn(u));
      if (typeof u == "string")
        return Fe(u);
      switch (u) {
        case c:
          return Fe("Suspense");
        case d:
          return Fe("SuspenseList");
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case l:
            return Et(u.render);
          case f:
            return kt(u.type, y, L);
          case R: {
            var z = u, oe = z._payload, ue = z._init;
            try {
              return kt(ue(oe), y, L);
            } catch {
            }
          }
        }
      return "";
    }
    var m = Object.prototype.hasOwnProperty, C = {}, j = E.ReactDebugCurrentFrame;
    function k(u) {
      if (u) {
        var y = u._owner, L = kt(u.type, u._source, y ? y.type : null);
        j.setExtraStackFrame(L);
      } else
        j.setExtraStackFrame(null);
    }
    function V(u, y, L, z, oe) {
      {
        var ue = Function.call.bind(m);
        for (var _ in u)
          if (ue(u, _)) {
            var Q = void 0;
            try {
              if (typeof u[_] != "function") {
                var Je = Error((z || "React class") + ": " + L + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Je.name = "Invariant Violation", Je;
              }
              Q = u[_](y, _, z, L, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Re) {
              Q = Re;
            }
            Q && !(Q instanceof Error) && (k(oe), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", z || "React class", L, _, typeof Q), k(null)), Q instanceof Error && !(Q.message in C) && (C[Q.message] = !0, k(oe), w("Failed %s type: %s", L, Q.message), k(null));
          }
      }
    }
    var F = Array.isArray;
    function X(u) {
      return F(u);
    }
    function fe(u) {
      {
        var y = typeof Symbol == "function" && Symbol.toStringTag, L = y && u[Symbol.toStringTag] || u.constructor.name || "Object";
        return L;
      }
    }
    function K(u) {
      try {
        return ne(u), !1;
      } catch {
        return !0;
      }
    }
    function ne(u) {
      return "" + u;
    }
    function ae(u) {
      if (K(u))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", fe(u)), ne(u);
    }
    var W = E.ReactCurrentOwner, pe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, qe, St, Te;
    Te = {};
    function Oe(u) {
      if (m.call(u, "ref")) {
        var y = Object.getOwnPropertyDescriptor(u, "ref").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return u.ref !== void 0;
    }
    function Ue(u) {
      if (m.call(u, "key")) {
        var y = Object.getOwnPropertyDescriptor(u, "key").get;
        if (y && y.isReactWarning)
          return !1;
      }
      return u.key !== void 0;
    }
    function vt(u, y) {
      if (typeof u.ref == "string" && W.current && y && W.current.stateNode !== y) {
        var L = te(W.current.type);
        Te[L] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', te(W.current.type), u.ref), Te[L] = !0);
      }
    }
    function Mt(u, y) {
      {
        var L = function() {
          qe || (qe = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        L.isReactWarning = !0, Object.defineProperty(u, "key", {
          get: L,
          configurable: !0
        });
      }
    }
    function et(u, y) {
      {
        var L = function() {
          St || (St = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", y));
        };
        L.isReactWarning = !0, Object.defineProperty(u, "ref", {
          get: L,
          configurable: !0
        });
      }
    }
    var Wt = function(u, y, L, z, oe, ue, _) {
      var Q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: u,
        key: y,
        ref: L,
        props: _,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return Q._store = {}, Object.defineProperty(Q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z
      }), Object.defineProperty(Q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: oe
      }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
    };
    function ke(u, y, L, z, oe) {
      {
        var ue, _ = {}, Q = null, Je = null;
        L !== void 0 && (ae(L), Q = "" + L), Ue(y) && (ae(y.key), Q = "" + y.key), Oe(y) && (Je = y.ref, vt(y, oe));
        for (ue in y)
          m.call(y, ue) && !pe.hasOwnProperty(ue) && (_[ue] = y[ue]);
        if (u && u.defaultProps) {
          var Re = u.defaultProps;
          for (ue in Re)
            _[ue] === void 0 && (_[ue] = Re[ue]);
        }
        if (Q || Je) {
          var ye = typeof u == "function" ? u.displayName || u.name || "Unknown" : u;
          Q && Mt(_, ye), Je && et(_, ye);
        }
        return Wt(u, Q, Je, oe, z, W.current, _);
      }
    }
    var Ct = E.ReactCurrentOwner, st = E.ReactDebugCurrentFrame;
    function Rt(u) {
      if (u) {
        var y = u._owner, L = kt(u.type, u._source, y ? y.type : null);
        st.setExtraStackFrame(L);
      } else
        st.setExtraStackFrame(null);
    }
    var $t;
    $t = !1;
    function Ut(u) {
      return typeof u == "object" && u !== null && u.$$typeof === t;
    }
    function Gt() {
      {
        if (Ct.current) {
          var u = te(Ct.current.type);
          if (u)
            return `

Check the render method of \`` + u + "`.";
        }
        return "";
      }
    }
    function Dt(u) {
      {
        if (u !== void 0) {
          var y = u.fileName.replace(/^.*[\\\/]/, ""), L = u.lineNumber;
          return `

Check your code at ` + y + ":" + L + ".";
        }
        return "";
      }
    }
    var Se = {};
    function ve(u) {
      {
        var y = Gt();
        if (!y) {
          var L = typeof u == "string" ? u : u.displayName || u.name;
          L && (y = `

Check the top-level render call using <` + L + ">.");
        }
        return y;
      }
    }
    function Be(u, y) {
      {
        if (!u._store || u._store.validated || u.key != null)
          return;
        u._store.validated = !0;
        var L = ve(y);
        if (Se[L])
          return;
        Se[L] = !0;
        var z = "";
        u && u._owner && u._owner !== Ct.current && (z = " It was passed a child from " + te(u._owner.type) + "."), Rt(u), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', L, z), Rt(null);
      }
    }
    function je(u, y) {
      {
        if (typeof u != "object")
          return;
        if (X(u))
          for (var L = 0; L < u.length; L++) {
            var z = u[L];
            Ut(z) && Be(z, y);
          }
        else if (Ut(u))
          u._store && (u._store.validated = !0);
        else if (u) {
          var oe = v(u);
          if (typeof oe == "function" && oe !== u.entries)
            for (var ue = oe.call(u), _; !(_ = ue.next()).done; )
              Ut(_.value) && Be(_.value, y);
        }
      }
    }
    function Ce(u) {
      {
        var y = u.type;
        if (y == null || typeof y == "string")
          return;
        var L;
        if (typeof y == "function")
          L = y.propTypes;
        else if (typeof y == "object" && (y.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        y.$$typeof === f))
          L = y.propTypes;
        else
          return;
        if (L) {
          var z = te(y);
          V(L, u.props, "prop", z, u);
        } else if (y.PropTypes !== void 0 && !$t) {
          $t = !0;
          var oe = te(y);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", oe || "Unknown");
        }
        typeof y.getDefaultProps == "function" && !y.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ae(u) {
      {
        for (var y = Object.keys(u.props), L = 0; L < y.length; L++) {
          var z = y[L];
          if (z !== "children" && z !== "key") {
            Rt(u), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", z), Rt(null);
            break;
          }
        }
        u.ref !== null && (Rt(u), w("Invalid attribute `ref` supplied to `React.Fragment`."), Rt(null));
      }
    }
    function Ze(u, y, L, z, oe, ue) {
      {
        var _ = Y(u);
        if (!_) {
          var Q = "";
          (u === void 0 || typeof u == "object" && u !== null && Object.keys(u).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Je = Dt(oe);
          Je ? Q += Je : Q += Gt();
          var Re;
          u === null ? Re = "null" : X(u) ? Re = "array" : u !== void 0 && u.$$typeof === t ? (Re = "<" + (te(u.type) || "Unknown") + " />", Q = " Did you accidentally export a JSX literal instead of a component?") : Re = typeof u, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Re, Q);
        }
        var ye = ke(u, y, L, oe, ue);
        if (ye == null)
          return ye;
        if (_) {
          var Ye = y.children;
          if (Ye !== void 0)
            if (z)
              if (X(Ye)) {
                for (var zt = 0; zt < Ye.length; zt++)
                  je(Ye[zt], u);
                Object.freeze && Object.freeze(Ye);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              je(Ye, u);
        }
        return u === r ? Ae(ye) : Ce(ye), ye;
      }
    }
    function tt(u, y, L) {
      return Ze(u, y, L, !0);
    }
    function It(u, y, L) {
      return Ze(u, y, L, !1);
    }
    var qo = It, Zo = tt;
    tn.Fragment = r, tn.jsx = qo, tn.jsxs = Zo;
  }()), tn;
}
process.env.NODE_ENV === "production" ? nr.exports = $o() : nr.exports = ei();
var T = nr.exports;
const Mu = () => /* @__PURE__ */ T.jsx("div", { children: "Demo Page" }), ti = "_container_zmnor_5", ni = "_price_zmnor_48", ri = "_goodsDivider_zmnor_83", hn = {
  "product-body": "_product-body_zmnor_1",
  container: ti,
  package: "_package_zmnor_17",
  price: ni,
  goodsDivider: ri
};
function oi(e) {
  return {
    type: "GET_IAP_PRODUCT",
    data: e
  };
}
function eo(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: ii } = Object.prototype, { getPrototypeOf: pr } = Object, Ln = ((e) => (t) => {
  const n = ii.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), lt = (e) => (e = e.toLowerCase(), (t) => Ln(t) === e), Pn = (e) => (t) => typeof t === e, { isArray: _t } = Array, cn = Pn("undefined");
function ai(e) {
  return e !== null && !cn(e) && e.constructor !== null && !cn(e.constructor) && $e(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const to = lt("ArrayBuffer");
function si(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && to(e.buffer), t;
}
const ci = Pn("string"), $e = Pn("function"), no = Pn("number"), Bn = (e) => e !== null && typeof e == "object", ui = (e) => e === !0 || e === !1, yn = (e) => {
  if (Ln(e) !== "object")
    return !1;
  const t = pr(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, li = lt("Date"), di = lt("File"), fi = lt("Blob"), pi = lt("FileList"), hi = (e) => Bn(e) && $e(e.pipe), gi = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || $e(e.append) && ((t = Ln(e)) === "formdata" || // detect form-data instance
  t === "object" && $e(e.toString) && e.toString() === "[object FormData]"));
}, mi = lt("URLSearchParams"), Ei = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function dn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), _t(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let s;
    for (r = 0; r < a; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function ro(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const oo = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), io = (e) => !cn(e) && e !== oo;
function rr() {
  const { caseless: e } = io(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && ro(t, o) || o;
    yn(t[i]) && yn(r) ? t[i] = rr(t[i], r) : yn(r) ? t[i] = rr({}, r) : _t(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && dn(arguments[r], n);
  return t;
}
const Si = (e, t, n, { allOwnKeys: r } = {}) => (dn(t, (o, i) => {
  n && $e(o) ? e[i] = eo(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), vi = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ri = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Ii = (e, t, n, r) => {
  let o, i, a;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && pr(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, yi = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Ai = (e) => {
  if (!e)
    return null;
  if (_t(e))
    return e;
  let t = e.length;
  if (!no(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, wi = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && pr(Uint8Array)), bi = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, Ti = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Oi = lt("HTMLFormElement"), ki = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), Tr = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ci = lt("RegExp"), ao = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  dn(n, (o, i) => {
    t(o, i, e) !== !1 && (r[i] = o);
  }), Object.defineProperties(e, r);
}, Di = (e) => {
  ao(e, (t, n) => {
    if ($e(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if ($e(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ni = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return _t(e) ? r(e) : r(String(e).split(t)), n;
}, Li = () => {
}, Pi = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Un = "abcdefghijklmnopqrstuvwxyz", Or = "0123456789", so = {
  DIGIT: Or,
  ALPHA: Un,
  ALPHA_DIGIT: Un + Un.toUpperCase() + Or
}, Bi = (e = 16, t = so.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function ji(e) {
  return !!(e && $e(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Hi = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (Bn(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = _t(r) ? [] : {};
        return dn(r, (a, s) => {
          const l = n(a, o + 1);
          !cn(l) && (i[s] = l);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Ji = lt("AsyncFunction"), xi = (e) => e && (Bn(e) || $e(e)) && $e(e.then) && $e(e.catch), S = {
  isArray: _t,
  isArrayBuffer: to,
  isBuffer: ai,
  isFormData: gi,
  isArrayBufferView: si,
  isString: ci,
  isNumber: no,
  isBoolean: ui,
  isObject: Bn,
  isPlainObject: yn,
  isUndefined: cn,
  isDate: li,
  isFile: di,
  isBlob: fi,
  isRegExp: Ci,
  isFunction: $e,
  isStream: hi,
  isURLSearchParams: mi,
  isTypedArray: wi,
  isFileList: pi,
  forEach: dn,
  merge: rr,
  extend: Si,
  trim: Ei,
  stripBOM: vi,
  inherits: Ri,
  toFlatObject: Ii,
  kindOf: Ln,
  kindOfTest: lt,
  endsWith: yi,
  toArray: Ai,
  forEachEntry: bi,
  matchAll: Ti,
  isHTMLForm: Oi,
  hasOwnProperty: Tr,
  hasOwnProp: Tr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ao,
  freezeMethods: Di,
  toObjectSet: Ni,
  toCamelCase: ki,
  noop: Li,
  toFiniteNumber: Pi,
  findKey: ro,
  global: oo,
  isContextDefined: io,
  ALPHABET: so,
  generateString: Bi,
  isSpecCompliantForm: ji,
  toJSONObject: Hi,
  isAsyncFn: Ji,
  isThenable: xi
};
function ee(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
S.inherits(ee, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: S.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const co = ee.prototype, uo = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  uo[e] = { value: e };
});
Object.defineProperties(ee, uo);
Object.defineProperty(co, "isAxiosError", { value: !0 });
ee.from = (e, t, n, r, o, i) => {
  const a = Object.create(co);
  return S.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), ee.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const Fi = null;
function or(e) {
  return S.isPlainObject(e) || S.isArray(e);
}
function lo(e) {
  return S.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function kr(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = lo(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function Mi(e) {
  return S.isArray(e) && !e.some(or);
}
const Wi = S.toFlatObject(S, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function jn(e, t, n) {
  if (!S.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = S.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, v) {
    return !S.isUndefined(v[g]);
  });
  const r = n.metaTokens, o = n.visitor || d, i = n.dots, a = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && S.isSpecCompliantForm(t);
  if (!S.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(h) {
    if (h === null)
      return "";
    if (S.isDate(h))
      return h.toISOString();
    if (!l && S.isBlob(h))
      throw new ee("Blob is not supported. Use a Buffer instead.");
    return S.isArrayBuffer(h) || S.isTypedArray(h) ? l && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function d(h, g, v) {
    let E = h;
    if (h && !v && typeof h == "object") {
      if (S.endsWith(g, "{}"))
        g = r ? g : g.slice(0, -2), h = JSON.stringify(h);
      else if (S.isArray(h) && Mi(h) || (S.isFileList(h) || S.endsWith(g, "[]")) && (E = S.toArray(h)))
        return g = lo(g), E.forEach(function(D, B) {
          !(S.isUndefined(D) || D === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? kr([g], B, i) : a === null ? g : g + "[]",
            c(D)
          );
        }), !1;
    }
    return or(h) ? !0 : (t.append(kr(v, g, i), c(h)), !1);
  }
  const f = [], R = Object.assign(Wi, {
    defaultVisitor: d,
    convertValue: c,
    isVisitable: or
  });
  function p(h, g) {
    if (!S.isUndefined(h)) {
      if (f.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      f.push(h), S.forEach(h, function(E, w) {
        (!(S.isUndefined(E) || E === null) && o.call(
          t,
          E,
          S.isString(w) ? w.trim() : w,
          g,
          R
        )) === !0 && p(E, g ? g.concat(w) : [w]);
      }), f.pop();
    }
  }
  if (!S.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function Cr(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function hr(e, t) {
  this._pairs = [], e && jn(e, this, t);
}
const fo = hr.prototype;
fo.append = function(t, n) {
  this._pairs.push([t, n]);
};
fo.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Cr);
  } : Cr;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function Ui(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function po(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Ui, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = S.isURLSearchParams(t) ? t.toString() : new hr(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Gi {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    S.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Dr = Gi, ho = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, zi = typeof URLSearchParams < "u" ? URLSearchParams : hr, Vi = typeof FormData < "u" ? FormData : null, qi = typeof Blob < "u" ? Blob : null, Zi = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Yi = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), ut = {
  isBrowser: !0,
  classes: {
    URLSearchParams: zi,
    FormData: Vi,
    Blob: qi
  },
  isStandardBrowserEnv: Zi,
  isStandardBrowserWebWorkerEnv: Yi,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Xi(e, t) {
  return jn(e, new ut.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return ut.isNode && S.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Ki(e) {
  return S.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Qi(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function go(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    const s = Number.isFinite(+a), l = i >= n.length;
    return a = !a && S.isArray(o) ? o.length : a, l ? (S.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !s) : ((!o[a] || !S.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && S.isArray(o[a]) && (o[a] = Qi(o[a])), !s);
  }
  if (S.isFormData(e) && S.isFunction(e.entries)) {
    const n = {};
    return S.forEachEntry(e, (r, o) => {
      t(Ki(r), o, n, 0);
    }), n;
  }
  return null;
}
const _i = {
  "Content-Type": void 0
};
function $i(e, t, n) {
  if (S.isString(e))
    try {
      return (t || JSON.parse)(e), S.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Hn = {
  transitional: ho,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = S.isObject(t);
    if (i && S.isHTMLForm(t) && (t = new FormData(t)), S.isFormData(t))
      return o && o ? JSON.stringify(go(t)) : t;
    if (S.isArrayBuffer(t) || S.isBuffer(t) || S.isStream(t) || S.isFile(t) || S.isBlob(t))
      return t;
    if (S.isArrayBufferView(t))
      return t.buffer;
    if (S.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Xi(t, this.formSerializer).toString();
      if ((s = S.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return jn(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), $i(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Hn.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (t && S.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? ee.from(s, ee.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ut.classes.FormData,
    Blob: ut.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
S.forEach(["delete", "get", "head"], function(t) {
  Hn.headers[t] = {};
});
S.forEach(["post", "put", "patch"], function(t) {
  Hn.headers[t] = S.merge(_i);
});
const gr = Hn, ea = S.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ta = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && ea[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Nr = Symbol("internals");
function nn(e) {
  return e && String(e).trim().toLowerCase();
}
function An(e) {
  return e === !1 || e == null ? e : S.isArray(e) ? e.map(An) : String(e);
}
function na(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const ra = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Gn(e, t, n, r, o) {
  if (S.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!S.isString(t)) {
    if (S.isString(r))
      return t.indexOf(r) !== -1;
    if (S.isRegExp(r))
      return r.test(t);
  }
}
function oa(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function ia(e, t) {
  const n = S.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class Jn {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(s, l, c) {
      const d = nn(l);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const f = S.findKey(o, d);
      (!f || o[f] === void 0 || c === !0 || c === void 0 && o[f] !== !1) && (o[f || l] = An(s));
    }
    const a = (s, l) => S.forEach(s, (c, d) => i(c, d, l));
    return S.isPlainObject(t) || t instanceof this.constructor ? a(t, n) : S.isString(t) && (t = t.trim()) && !ra(t) ? a(ta(t), n) : t != null && i(n, t, r), this;
  }
  get(t, n) {
    if (t = nn(t), t) {
      const r = S.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return na(o);
        if (S.isFunction(n))
          return n.call(this, o, r);
        if (S.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = nn(t), t) {
      const r = S.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Gn(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = nn(a), a) {
        const s = S.findKey(r, a);
        s && (!n || Gn(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return S.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || Gn(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return S.forEach(this, (o, i) => {
      const a = S.findKey(r, i);
      if (a) {
        n[a] = An(o), delete n[i];
        return;
      }
      const s = t ? oa(i) : String(i).trim();
      s !== i && delete n[i], n[s] = An(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return S.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && S.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[Nr] = this[Nr] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const s = nn(a);
      r[s] || (ia(o, a), r[s] = !0);
    }
    return S.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
Jn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
S.freezeMethods(Jn.prototype);
S.freezeMethods(Jn);
const mt = Jn;
function zn(e, t) {
  const n = this || gr, r = t || n, o = mt.from(r.headers);
  let i = r.data;
  return S.forEach(e, function(s) {
    i = s.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function mo(e) {
  return !!(e && e.__CANCEL__);
}
function fn(e, t, n) {
  ee.call(this, e ?? "canceled", ee.ERR_CANCELED, t, n), this.name = "CanceledError";
}
S.inherits(fn, ee, {
  __CANCEL__: !0
});
function aa(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new ee(
    "Request failed with status code " + n.status,
    [ee.ERR_BAD_REQUEST, ee.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const sa = ut.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, r, o, i, a, s) {
        const l = [];
        l.push(n + "=" + encodeURIComponent(r)), S.isNumber(o) && l.push("expires=" + new Date(o).toGMTString()), S.isString(i) && l.push("path=" + i), S.isString(a) && l.push("domain=" + a), s === !0 && l.push("secure"), document.cookie = l.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function ca(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function ua(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Eo(e, t) {
  return e && !ca(t) ? ua(e, t) : t;
}
const la = ut.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let a = i;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const s = S.isString(a) ? o(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function da(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function fa(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), d = r[i];
    a || (a = c), n[o] = l, r[o] = c;
    let f = i, R = 0;
    for (; f !== o; )
      R += n[f++], f = f % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), c - a < t)
      return;
    const p = d && c - d;
    return p ? Math.round(R * 1e3 / p) : void 0;
  };
}
function Lr(e, t) {
  let n = 0;
  const r = fa(50, 250);
  return (o) => {
    const i = o.loaded, a = o.lengthComputable ? o.total : void 0, s = i - n, l = r(s), c = i <= a;
    n = i;
    const d = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: s,
      rate: l || void 0,
      estimated: l && a && c ? (a - i) / l : void 0,
      event: o
    };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
const pa = typeof XMLHttpRequest < "u", ha = pa && function(e) {
  return new Promise(function(n, r) {
    let o = e.data;
    const i = mt.from(e.headers).normalize(), a = e.responseType;
    let s;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(s), e.signal && e.signal.removeEventListener("abort", s);
    }
    S.isFormData(o) && (ut.isStandardBrowserEnv || ut.isStandardBrowserWebWorkerEnv ? i.setContentType(!1) : i.setContentType("multipart/form-data;", !1));
    let c = new XMLHttpRequest();
    if (e.auth) {
      const p = e.auth.username || "", h = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(p + ":" + h));
    }
    const d = Eo(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), po(d, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function f() {
      if (!c)
        return;
      const p = mt.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), g = {
        data: !a || a === "text" || a === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: p,
        config: e,
        request: c
      };
      aa(function(E) {
        n(E), l();
      }, function(E) {
        r(E), l();
      }, g), c = null;
    }
    if ("onloadend" in c ? c.onloadend = f : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, c.onabort = function() {
      c && (r(new ee("Request aborted", ee.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      r(new ee("Network Error", ee.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let h = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const g = e.transitional || ho;
      e.timeoutErrorMessage && (h = e.timeoutErrorMessage), r(new ee(
        h,
        g.clarifyTimeoutError ? ee.ETIMEDOUT : ee.ECONNABORTED,
        e,
        c
      )), c = null;
    }, ut.isStandardBrowserEnv) {
      const p = (e.withCredentials || la(d)) && e.xsrfCookieName && sa.read(e.xsrfCookieName);
      p && i.set(e.xsrfHeaderName, p);
    }
    o === void 0 && i.setContentType(null), "setRequestHeader" in c && S.forEach(i.toJSON(), function(h, g) {
      c.setRequestHeader(g, h);
    }), S.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), a && a !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", Lr(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", Lr(e.onUploadProgress)), (e.cancelToken || e.signal) && (s = (p) => {
      c && (r(!p || p.type ? new fn(null, e, c) : p), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(s), e.signal && (e.signal.aborted ? s() : e.signal.addEventListener("abort", s)));
    const R = da(d);
    if (R && ut.protocols.indexOf(R) === -1) {
      r(new ee("Unsupported protocol " + R + ":", ee.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(o || null);
  });
}, wn = {
  http: Fi,
  xhr: ha
};
S.forEach(wn, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ga = {
  getAdapter: (e) => {
    e = S.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let o = 0; o < t && (n = e[o], !(r = S.isString(n) ? wn[n.toLowerCase()] : n)); o++)
      ;
    if (!r)
      throw r === !1 ? new ee(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        S.hasOwnProp(wn, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!S.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: wn
};
function Vn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new fn(null, e);
}
function Pr(e) {
  return Vn(e), e.headers = mt.from(e.headers), e.data = zn.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ga.getAdapter(e.adapter || gr.adapter)(e).then(function(r) {
    return Vn(e), r.data = zn.call(
      e,
      e.transformResponse,
      r
    ), r.headers = mt.from(r.headers), r;
  }, function(r) {
    return mo(r) || (Vn(e), r && r.response && (r.response.data = zn.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = mt.from(r.response.headers))), Promise.reject(r);
  });
}
const Br = (e) => e instanceof mt ? e.toJSON() : e;
function Kt(e, t) {
  t = t || {};
  const n = {};
  function r(c, d, f) {
    return S.isPlainObject(c) && S.isPlainObject(d) ? S.merge.call({ caseless: f }, c, d) : S.isPlainObject(d) ? S.merge({}, d) : S.isArray(d) ? d.slice() : d;
  }
  function o(c, d, f) {
    if (S.isUndefined(d)) {
      if (!S.isUndefined(c))
        return r(void 0, c, f);
    } else
      return r(c, d, f);
  }
  function i(c, d) {
    if (!S.isUndefined(d))
      return r(void 0, d);
  }
  function a(c, d) {
    if (S.isUndefined(d)) {
      if (!S.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, d);
  }
  function s(c, d, f) {
    if (f in t)
      return r(c, d);
    if (f in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (c, d) => o(Br(c), Br(d), !0)
  };
  return S.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const f = l[d] || o, R = f(e[d], t[d], d);
    S.isUndefined(R) && f !== s || (n[d] = R);
  }), n;
}
const So = "1.4.0", mr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  mr[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const jr = {};
mr.transitional = function(t, n, r) {
  function o(i, a) {
    return "[Axios v" + So + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, s) => {
    if (t === !1)
      throw new ee(
        o(a, " has been removed" + (n ? " in " + n : "")),
        ee.ERR_DEPRECATED
      );
    return n && !jr[a] && (jr[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function ma(e, t, n) {
  if (typeof e != "object")
    throw new ee("options must be an object", ee.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const s = e[i], l = s === void 0 || a(s, i, e);
      if (l !== !0)
        throw new ee("option " + i + " must be " + l, ee.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new ee("Unknown option " + i, ee.ERR_BAD_OPTION);
  }
}
const ir = {
  assertOptions: ma,
  validators: mr
}, yt = ir.validators;
class kn {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Dr(),
      response: new Dr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Kt(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && ir.assertOptions(r, {
      silentJSONParsing: yt.transitional(yt.boolean),
      forcedJSONParsing: yt.transitional(yt.boolean),
      clarifyTimeoutError: yt.transitional(yt.boolean)
    }, !1), o != null && (S.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : ir.assertOptions(o, {
      encode: yt.function,
      serialize: yt.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a;
    a = i && S.merge(
      i.common,
      i[n.method]
    ), a && S.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), n.headers = mt.concat(a, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(n) === !1 || (l = l && g.synchronous, s.unshift(g.fulfilled, g.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(g) {
      c.push(g.fulfilled, g.rejected);
    });
    let d, f = 0, R;
    if (!l) {
      const h = [Pr.bind(this), void 0];
      for (h.unshift.apply(h, s), h.push.apply(h, c), R = h.length, d = Promise.resolve(n); f < R; )
        d = d.then(h[f++], h[f++]);
      return d;
    }
    R = s.length;
    let p = n;
    for (f = 0; f < R; ) {
      const h = s[f++], g = s[f++];
      try {
        p = h(p);
      } catch (v) {
        g.call(this, v);
        break;
      }
    }
    try {
      d = Pr.call(this, p);
    } catch (h) {
      return Promise.reject(h);
    }
    for (f = 0, R = c.length; f < R; )
      d = d.then(c[f++], c[f++]);
    return d;
  }
  getUri(t) {
    t = Kt(this.defaults, t);
    const n = Eo(t.baseURL, t.url);
    return po(n, t.params, t.paramsSerializer);
  }
}
S.forEach(["delete", "get", "head", "options"], function(t) {
  kn.prototype[t] = function(n, r) {
    return this.request(Kt(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
S.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, s) {
      return this.request(Kt(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  kn.prototype[t] = n(), kn.prototype[t + "Form"] = n(!0);
});
const bn = kn;
class Er {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, s) {
      r.reason || (r.reason = new fn(i, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Er(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const Ea = Er;
function Sa(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function va(e) {
  return S.isObject(e) && e.isAxiosError === !0;
}
const ar = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ar).forEach(([e, t]) => {
  ar[t] = e;
});
const Ra = ar;
function vo(e) {
  const t = new bn(e), n = eo(bn.prototype.request, t);
  return S.extend(n, bn.prototype, t, { allOwnKeys: !0 }), S.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return vo(Kt(e, o));
  }, n;
}
const be = vo(gr);
be.Axios = bn;
be.CanceledError = fn;
be.CancelToken = Ea;
be.isCancel = mo;
be.VERSION = So;
be.toFormData = jn;
be.AxiosError = ee;
be.Cancel = be.CanceledError;
be.all = function(t) {
  return Promise.all(t);
};
be.spread = Sa;
be.isAxiosError = va;
be.mergeConfig = Kt;
be.AxiosHeaders = mt;
be.formToJSON = (e) => go(S.isHTMLForm(e) ? new FormData(e) : e);
be.HttpStatusCode = Ra;
be.default = be;
const Ia = be;
let gn;
const ya = new Uint8Array(16);
function Aa() {
  if (!gn && (gn = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !gn))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return gn(ya);
}
const De = [];
for (let e = 0; e < 256; ++e)
  De.push((e + 256).toString(16).slice(1));
function wa(e, t = 0) {
  return (De[e[t + 0]] + De[e[t + 1]] + De[e[t + 2]] + De[e[t + 3]] + "-" + De[e[t + 4]] + De[e[t + 5]] + "-" + De[e[t + 6]] + De[e[t + 7]] + "-" + De[e[t + 8]] + De[e[t + 9]] + "-" + De[e[t + 10]] + De[e[t + 11]] + De[e[t + 12]] + De[e[t + 13]] + De[e[t + 14]] + De[e[t + 15]]).toLowerCase();
}
const ba = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hr = {
  randomUUID: ba
};
function un(e, t, n) {
  if (Hr.randomUUID && !t && !e)
    return Hr.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || Aa)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return wa(r);
}
let ze = class {
};
ze.ACCESS_TOKEN_EXPIRED = "00100100004016";
ze.ACCESS_TOKEN_INVALID = "00100100004014";
ze.REFRESH_TOKEN_EXPIRED = "00100100004017";
ze.REFRESH_TOKEN_INVALID = "00100100004015";
const Ro = {
  /**
   * 获取数据类型
   * @param params 
   * @returns 'String','Number'...
   */
  getTypeOf: (e) => {
    let t = Object.prototype.toString.call(e).match(/\[\w+\W(\w+)\]$/);
    return t ? t[1] : null;
  },
  /**
   * https://stackoverflow.com/questions/69983708/how-to-make-the-javascript-null-check-more-clear
   * 数据空检查
   * @param AnyObject
   * @returns 
   */
  isNull: (e) => !!(!e || typeof e == "object" && (Array.isArray(e) && e.length === 0 || e.toString() === "[object Object]" && JSON.stringify(e) === "{}")),
  /**
   * https://stackoverflow.com/questions/23437476/in-typescript-how-to-check-if-a-string-is-numeric
   * @param value 
   * @returns 
   */
  isNumber: (e) => e != null && e !== "" && !isNaN(Number(e.toString())),
  /**
   * 数组，字符串去重
   * @param Array,String
   * @returns 
   */
  unique: function(e) {
  },
  genRandomStr: function(e) {
    let t = "";
    const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = n.length;
    let o = 0;
    for (; o < e; )
      t += n.charAt(Math.floor(Math.random() * r)), o += 1;
    return t;
  },
  joinUrl: (...e) => e.map((t) => t.replace(/^\/|\/$/g, "")).join("/")
};
let Z = class {
};
Z.MOUSE_UP = "mouseup";
Z.MOUSE_CLICK = "click";
Z.ACCESS_TOKEN_NAME = "x-access-token";
Z.REFRESH_TOKEN_NAME = "x-refresh-token";
Z.REQUEST_ID_NAME = "x-request-id";
Z.REDDWARF_APP_ID_KEY = "app-id";
Z.REDDWARF_PRODUCT_ID_KEY = "product-id";
Z.USER_NAME = "username";
Z.PASSWORD = "password";
Z.BASE_AUTH_URL = "base-auth-url";
Z.USER_LOGIN_URL_PATH = "user-login-url-path";
Z.ACCESS_TOKEN_URL_PATH = "access-token-url-path";
Z.REFRESH_TOKEN_URL_PATH = "refresh-token-url-path";
const ht = {
  set: async (e, t) => new Promise((n, r) => {
    window.localStorage.setItem(e, t);
  }),
  readLocalStorage: async (e) => new Promise((t, n) => {
    chrome.storage.local.get([e], function(r) {
      r[e] === void 0 ? t("") : t(r[e]);
    });
  }),
  setLocalStorage: async (e, t) => new Promise((n, r) => {
    chrome.storage.local.set({
      [e]: t
    }, function() {
      n("");
    });
  })
}, Ta = Object.freeze({
  PHONE: 1
}), Oa = {
  getDeviceId: async () => new Promise((e, t) => {
    e("xxxx");
  }),
  getDeviceIdEnhance: async () => new Promise((e, t) => {
    require("@fingerprintjs/fingerprintjs").load().then((n) => n.get()).then(async (n) => {
      const r = n.visitorId;
      e(r);
    });
  })
}, Sr = {
  isTokenNeedRefresh: (e) => {
    const t = localStorage.getItem(Z.ACCESS_TOKEN_NAME);
    if (!t)
      return !1;
    const n = JSON.parse(atob(t.split(".")[1])).exp, r = Math.floor(Date.now() / 1e3);
    return n < r + e;
  },
  storeLoginAuthInfo: (e, t, n) => {
    localStorage.setItem("isLoggedIn", "true"), localStorage.setItem(Z.ACCESS_TOKEN_NAME, e.accessToken), localStorage.setItem(Z.REFRESH_TOKEN_NAME, e.refreshToken), localStorage.setItem("avatarUrl", e.avatarUrl ? e.avatarUrl : ""), localStorage.setItem(Z.BASE_AUTH_URL, t), localStorage.setItem(Z.ACCESS_TOKEN_URL_PATH, n);
  },
  storeCookieAuthInfo: (e, t, n) => {
    var r, o;
    const i = e.split("=")[1], a = (r = document.cookie.split("; ").find((l) => l.startsWith("refreshToken="))) == null ? void 0 : r.split("=")[1], s = (o = document.cookie.split("; ").find((l) => l.startsWith("avatarUrl="))) == null ? void 0 : o.split("=")[1];
    localStorage.setItem("isLoggedIn", "true"), localStorage.setItem(Z.ACCESS_TOKEN_NAME, i), localStorage.setItem(Z.REFRESH_TOKEN_NAME, a || ""), localStorage.setItem("avatarUrl", s || ""), localStorage.setItem(Z.BASE_AUTH_URL, t), localStorage.setItem(Z.ACCESS_TOKEN_URL_PATH, n);
  },
  pluginLogin: async () => {
    let e = await ht.readLocalStorage(Z.USER_NAME), t = await ht.readLocalStorage(Z.PASSWORD), n = await Oa.getDeviceIdEnhance(), r = await ht.readLocalStorage(Z.REDDWARF_APP_ID_KEY), o = {
      phone: e,
      password: t,
      deviceId: n,
      deviceName: n,
      appId: Number(r),
      deviceType: 7,
      loginType: Ta.PHONE
    };
    return Sr.login(o);
  },
  login: async (e) => {
    const t = await ht.readLocalStorage(Z.BASE_AUTH_URL), n = await ht.readLocalStorage(Z.USER_LOGIN_URL_PATH), r = t + n;
    let o = await (await fetch(r, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(e)
    })).json();
    if (o && o.result && o.result.accessToken) {
      const i = o.result.accessToken, a = o.result.refreshToken;
      chrome.storage.local.set(
        {
          [Z.ACCESS_TOKEN_NAME]: i,
          [Z.REFRESH_TOKEN_NAME]: a
        }
      );
    }
    return o;
  }
};
var mn, ka = new Uint8Array(16);
function Ca() {
  if (!mn && (mn = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !mn))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return mn(ka);
}
const Da = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Na(e) {
  return typeof e == "string" && Da.test(e);
}
var Ne = [];
for (var qn = 0; qn < 256; ++qn)
  Ne.push((qn + 256).toString(16).substr(1));
function La(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (Ne[e[t + 0]] + Ne[e[t + 1]] + Ne[e[t + 2]] + Ne[e[t + 3]] + "-" + Ne[e[t + 4]] + Ne[e[t + 5]] + "-" + Ne[e[t + 6]] + Ne[e[t + 7]] + "-" + Ne[e[t + 8]] + Ne[e[t + 9]] + "-" + Ne[e[t + 10]] + Ne[e[t + 11]] + Ne[e[t + 12]] + Ne[e[t + 13]] + Ne[e[t + 14]] + Ne[e[t + 15]]).toLowerCase();
  if (!Na(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function Pa(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || Ca)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return La(r);
}
var En = !1;
const Ke = {
  post: async (e, t) => En === !0 ? void 0 : await Ke.api_post(e, t).then((n) => {
    if (n.resultCode === ze.ACCESS_TOKEN_EXPIRED)
      En = !0, Ke.handleAccessTokenExpire();
    else
      return n;
  }),
  api_post: async (e, t) => {
    let n = await ht.readLocalStorage(Z.ACCESS_TOKEN_NAME);
    return n ? await Ke.do_api_post(e, t, n) : (await Sr.pluginLogin(), await Ke.do_api_post(e, t, n));
  },
  do_api_post: async (e, t, n) => fetch(e, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      // https://self-issued.info/docs/draft-ietf-oauth-v2-bearer.html#query-param
      Authorization: "Bearer " + n,
      "x-request-id": Pa()
    },
    body: JSON.stringify(t)
  }).then((r) => {
    if (!r.ok)
      throw new Error(r.statusText);
    return r.json();
  }),
  handleRefreshTokenInvalid: async () => {
    window.location.href = "/user/login";
  },
  handleWebAccessTokenExpire: async () => {
    const e = {
      grant_type: "refresh_token",
      refresh_token: localStorage.getItem(Z.REFRESH_TOKEN_NAME)
    };
    return await Ke.refreshWebAccessToken(e);
  },
  handleAccessTokenExpire: async () => {
    const e = {
      grant_type: "refresh_token",
      refresh_token: await ht.readLocalStorage(Z.REFRESH_TOKEN_NAME)
    };
    Ke.refreshAccessToken(e);
  },
  refreshWebAccessToken: async (e) => {
    const t = localStorage.getItem(Z.BASE_AUTH_URL), n = localStorage.getItem(Z.ACCESS_TOKEN_URL_PATH), r = t + n;
    return fetch(r, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(e)
    }).then((o) => o.json()).then((o) => {
      if (Ot.responseSuccess(o)) {
        const i = o.result.accessToken;
        return localStorage.setItem(Z.ACCESS_TOKEN_NAME, i), En = !1, Promise.resolve(o);
      } else
        window.location.href = "/user/login";
      return Promise.reject(o);
    });
  },
  refreshAccessToken: async (e) => {
    const t = await ht.readLocalStorage(Z.BASE_AUTH_URL), n = await ht.readLocalStorage(Z.ACCESS_TOKEN_URL_PATH), r = t + n;
    fetch(r, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(e)
    }).then((o) => o.json()).then((o) => {
      if ((o && o.resultCode === ze.REFRESH_TOKEN_EXPIRED || o && o.resultCode === ze.REFRESH_TOKEN_INVALID) && Ke.handleRefreshTokenInvalid(), o && o.resultCode === "200") {
        const i = o.result.accessToken;
        chrome.storage.local.set(
          {
            [Z.ACCESS_TOKEN_NAME]: i
          },
          function() {
            En = !1;
          }
        );
      }
    });
  }
}, Ot = {
  responseSuccess: (e) => Ro.isNull(e) ? !1 : e.statusCode === "200" && e.resultCode === "200",
  handleCommonFailure: (e) => {
    e.resultCode === ze.ACCESS_TOKEN_EXPIRED && Ke.handleAccessTokenExpire();
  },
  handleWebCommonFailure: async (e) => {
    if (e.resultCode === ze.ACCESS_TOKEN_EXPIRED)
      return await Ke.handleWebAccessTokenExpire();
  },
  mapPageResponse: (e) => ({
    data: e.result.list,
    pagination: {
      total: e.result.pagination.total,
      pageSize: e.result.pagination.pageSize,
      pageNum: e.result.pagination.pageNum
    }
  }),
  mapUnwrapPage: (e) => ({
    data: e.list,
    pagination: {
      total: e.pagination.total,
      pageSize: e.pagination.pageSize,
      pageNum: e.pagination.pageNum
    }
  })
};
var Ba = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ja(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Io = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ba, function() {
    var n = 1e3, r = 6e4, o = 36e5, i = "millisecond", a = "second", s = "minute", l = "hour", c = "day", d = "week", f = "month", R = "quarter", p = "year", h = "date", g = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, w = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(N) {
      var b = ["th", "st", "nd", "rd"], I = N % 100;
      return "[" + N + (b[(I - 20) % 10] || b[I] || b[0]) + "]";
    } }, D = function(N, b, I) {
      var O = String(N);
      return !O || O.length >= b ? N : "" + Array(b + 1 - O.length).join(I) + N;
    }, B = { s: D, z: function(N) {
      var b = -N.utcOffset(), I = Math.abs(b), O = Math.floor(I / 60), A = I % 60;
      return (b <= 0 ? "+" : "-") + D(O, 2, "0") + ":" + D(A, 2, "0");
    }, m: function N(b, I) {
      if (b.date() < I.date())
        return -N(I, b);
      var O = 12 * (I.year() - b.year()) + (I.month() - b.month()), A = b.clone().add(O, f), x = I - A < 0, P = b.clone().add(O + (x ? -1 : 1), f);
      return +(-(O + (I - A) / (x ? A - P : P - A)) || 0);
    }, a: function(N) {
      return N < 0 ? Math.ceil(N) || 0 : Math.floor(N);
    }, p: function(N) {
      return { M: f, y: p, w: d, d: c, D: h, h: l, m: s, s: a, ms: i, Q: R }[N] || String(N || "").toLowerCase().replace(/s$/, "");
    }, u: function(N) {
      return N === void 0;
    } }, U = "en", $ = {};
    $[U] = w;
    var se = "$isDayjsObject", H = function(N) {
      return N instanceof J || !(!N || !N[se]);
    }, de = function N(b, I, O) {
      var A;
      if (!b)
        return U;
      if (typeof b == "string") {
        var x = b.toLowerCase();
        $[x] && (A = x), I && ($[x] = I, A = x);
        var P = b.split("-");
        if (!A && P.length > 1)
          return N(P[0]);
      } else {
        var M = b.name;
        $[M] = b, A = M;
      }
      return !O && A && (U = A), A || !O && U;
    }, Y = function(N, b) {
      if (H(N))
        return N.clone();
      var I = typeof b == "object" ? b : {};
      return I.date = N, I.args = arguments, new J(I);
    }, G = B;
    G.l = de, G.i = H, G.w = function(N, b) {
      return Y(N, { locale: b.$L, utc: b.$u, x: b.$x, $offset: b.$offset });
    };
    var J = function() {
      function N(I) {
        this.$L = de(I.locale, null, !0), this.parse(I), this.$x = this.$x || I.x || {}, this[se] = !0;
      }
      var b = N.prototype;
      return b.parse = function(I) {
        this.$d = function(O) {
          var A = O.date, x = O.utc;
          if (A === null)
            return /* @__PURE__ */ new Date(NaN);
          if (G.u(A))
            return /* @__PURE__ */ new Date();
          if (A instanceof Date)
            return new Date(A);
          if (typeof A == "string" && !/Z$/i.test(A)) {
            var P = A.match(v);
            if (P) {
              var M = P[2] - 1 || 0, ce = (P[7] || "0").substring(0, 3);
              return x ? new Date(Date.UTC(P[1], M, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, ce)) : new Date(P[1], M, P[3] || 1, P[4] || 0, P[5] || 0, P[6] || 0, ce);
            }
          }
          return new Date(A);
        }(I), this.init();
      }, b.init = function() {
        var I = this.$d;
        this.$y = I.getFullYear(), this.$M = I.getMonth(), this.$D = I.getDate(), this.$W = I.getDay(), this.$H = I.getHours(), this.$m = I.getMinutes(), this.$s = I.getSeconds(), this.$ms = I.getMilliseconds();
      }, b.$utils = function() {
        return G;
      }, b.isValid = function() {
        return this.$d.toString() !== g;
      }, b.isSame = function(I, O) {
        var A = Y(I);
        return this.startOf(O) <= A && A <= this.endOf(O);
      }, b.isAfter = function(I, O) {
        return Y(I) < this.startOf(O);
      }, b.isBefore = function(I, O) {
        return this.endOf(O) < Y(I);
      }, b.$g = function(I, O, A) {
        return G.u(I) ? this[O] : this.set(A, I);
      }, b.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, b.valueOf = function() {
        return this.$d.getTime();
      }, b.startOf = function(I, O) {
        var A = this, x = !!G.u(O) || O, P = G.p(I), M = function(He, le) {
          var Ee = G.w(A.$u ? Date.UTC(A.$y, le, He) : new Date(A.$y, le, He), A);
          return x ? Ee : Ee.endOf(c);
        }, ce = function(He, le) {
          return G.w(A.toDate()[He].apply(A.toDate("s"), (x ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(le)), A);
        }, he = this.$W, Ie = this.$M, Pe = this.$D, Ve = "set" + (this.$u ? "UTC" : "");
        switch (P) {
          case p:
            return x ? M(1, 0) : M(31, 11);
          case f:
            return x ? M(1, Ie) : M(0, Ie + 1);
          case d:
            var We = this.$locale().weekStart || 0, Fe = (he < We ? he + 7 : he) - We;
            return M(x ? Pe - Fe : Pe + (6 - Fe), Ie);
          case c:
          case h:
            return ce(Ve + "Hours", 0);
          case l:
            return ce(Ve + "Minutes", 1);
          case s:
            return ce(Ve + "Seconds", 2);
          case a:
            return ce(Ve + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, b.endOf = function(I) {
        return this.startOf(I, !1);
      }, b.$set = function(I, O) {
        var A, x = G.p(I), P = "set" + (this.$u ? "UTC" : ""), M = (A = {}, A[c] = P + "Date", A[h] = P + "Date", A[f] = P + "Month", A[p] = P + "FullYear", A[l] = P + "Hours", A[s] = P + "Minutes", A[a] = P + "Seconds", A[i] = P + "Milliseconds", A)[x], ce = x === c ? this.$D + (O - this.$W) : O;
        if (x === f || x === p) {
          var he = this.clone().set(h, 1);
          he.$d[M](ce), he.init(), this.$d = he.set(h, Math.min(this.$D, he.daysInMonth())).$d;
        } else
          M && this.$d[M](ce);
        return this.init(), this;
      }, b.set = function(I, O) {
        return this.clone().$set(I, O);
      }, b.get = function(I) {
        return this[G.p(I)]();
      }, b.add = function(I, O) {
        var A, x = this;
        I = Number(I);
        var P = G.p(O), M = function(Ie) {
          var Pe = Y(x);
          return G.w(Pe.date(Pe.date() + Math.round(Ie * I)), x);
        };
        if (P === f)
          return this.set(f, this.$M + I);
        if (P === p)
          return this.set(p, this.$y + I);
        if (P === c)
          return M(1);
        if (P === d)
          return M(7);
        var ce = (A = {}, A[s] = r, A[l] = o, A[a] = n, A)[P] || 1, he = this.$d.getTime() + I * ce;
        return G.w(he, this);
      }, b.subtract = function(I, O) {
        return this.add(-1 * I, O);
      }, b.format = function(I) {
        var O = this, A = this.$locale();
        if (!this.isValid())
          return A.invalidDate || g;
        var x = I || "YYYY-MM-DDTHH:mm:ssZ", P = G.z(this), M = this.$H, ce = this.$m, he = this.$M, Ie = A.weekdays, Pe = A.months, Ve = A.meridiem, We = function(le, Ee, at, Et) {
          return le && (le[Ee] || le(O, x)) || at[Ee].slice(0, Et);
        }, Fe = function(le) {
          return G.s(M % 12 || 12, le, "0");
        }, He = Ve || function(le, Ee, at) {
          var Et = le < 12 ? "AM" : "PM";
          return at ? Et.toLowerCase() : Et;
        };
        return x.replace(E, function(le, Ee) {
          return Ee || function(at) {
            switch (at) {
              case "YY":
                return String(O.$y).slice(-2);
              case "YYYY":
                return G.s(O.$y, 4, "0");
              case "M":
                return he + 1;
              case "MM":
                return G.s(he + 1, 2, "0");
              case "MMM":
                return We(A.monthsShort, he, Pe, 3);
              case "MMMM":
                return We(Pe, he);
              case "D":
                return O.$D;
              case "DD":
                return G.s(O.$D, 2, "0");
              case "d":
                return String(O.$W);
              case "dd":
                return We(A.weekdaysMin, O.$W, Ie, 2);
              case "ddd":
                return We(A.weekdaysShort, O.$W, Ie, 3);
              case "dddd":
                return Ie[O.$W];
              case "H":
                return String(M);
              case "HH":
                return G.s(M, 2, "0");
              case "h":
                return Fe(1);
              case "hh":
                return Fe(2);
              case "a":
                return He(M, ce, !0);
              case "A":
                return He(M, ce, !1);
              case "m":
                return String(ce);
              case "mm":
                return G.s(ce, 2, "0");
              case "s":
                return String(O.$s);
              case "ss":
                return G.s(O.$s, 2, "0");
              case "SSS":
                return G.s(O.$ms, 3, "0");
              case "Z":
                return P;
            }
            return null;
          }(le) || P.replace(":", "");
        });
      }, b.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, b.diff = function(I, O, A) {
        var x, P = this, M = G.p(O), ce = Y(I), he = (ce.utcOffset() - this.utcOffset()) * r, Ie = this - ce, Pe = function() {
          return G.m(P, ce);
        };
        switch (M) {
          case p:
            x = Pe() / 12;
            break;
          case f:
            x = Pe();
            break;
          case R:
            x = Pe() / 3;
            break;
          case d:
            x = (Ie - he) / 6048e5;
            break;
          case c:
            x = (Ie - he) / 864e5;
            break;
          case l:
            x = Ie / o;
            break;
          case s:
            x = Ie / r;
            break;
          case a:
            x = Ie / n;
            break;
          default:
            x = Ie;
        }
        return A ? x : G.a(x);
      }, b.daysInMonth = function() {
        return this.endOf(f).$D;
      }, b.$locale = function() {
        return $[this.$L];
      }, b.locale = function(I, O) {
        if (!I)
          return this.$L;
        var A = this.clone(), x = de(I, O, !0);
        return x && (A.$L = x), A;
      }, b.clone = function() {
        return G.w(this.$d, this);
      }, b.toDate = function() {
        return new Date(this.valueOf());
      }, b.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, b.toISOString = function() {
        return this.$d.toISOString();
      }, b.toString = function() {
        return this.$d.toUTCString();
      }, N;
    }(), te = J.prototype;
    return Y.prototype = te, [["$ms", i], ["$s", a], ["$m", s], ["$H", l], ["$W", c], ["$M", f], ["$y", p], ["$D", h]].forEach(function(N) {
      te[N[1]] = function(b) {
        return this.$g(b, N[0], N[1]);
      };
    }), Y.extend = function(N, b) {
      return N.$i || (N(b, J, Y), N.$i = !0), Y;
    }, Y.locale = de, Y.isDayjs = H, Y.unix = function(N) {
      return Y(1e3 * N);
    }, Y.en = $[U], Y.Ls = $, Y.p = {}, Y;
  });
})(Io);
var Ha = Io.exports;
const Zn = /* @__PURE__ */ ja(Ha), wt = {
  getMonthStart: () => {
    Zn().startOf("month").add(1, "day").set("year", 2018).format("YYYY-MM-DD HH:mm:ss");
  },
  getMonthStartMilliseconds: () => {
    Zn().startOf("month").valueOf();
  },
  getMonthEndMilliseconds: () => {
    Zn().endOf("month").valueOf();
  },
  getFormattedTime(e) {
    var t = new Date(e);
    return wt.getCurrentFormattedTime(t);
  },
  getCurrentFormattedTime(e = /* @__PURE__ */ new Date()) {
    const t = e.getFullYear(), n = wt.padLeftZero(e.getMonth() + 1), r = wt.padLeftZero(e.getDate()), o = wt.padLeftZero(e.getHours()), i = wt.padLeftZero(e.getMinutes()), a = wt.padLeftZero(e.getSeconds()), s = wt.padLeftZero(e.getMilliseconds(), 3);
    return `${t}-${n}-${r} ${o}:${i}:${a} ${s}`;
  },
  padLeftZero(e, t = 2) {
    return (Array(t).join("0") + e).slice(-t);
  },
  getPrevFormattedTime: (e) => {
    let t = /* @__PURE__ */ new Date(), n = parseInt((t.getTime() / 1e3).toString()), r = new Date(e), o = parseInt((r.getTime() / 1e3).toString()), i = r.getFullYear(), a = r.getMonth() + 1, s = r.getDate(), l = r.getHours(), c = r.getMinutes();
    r.getSeconds();
    let d = n - o;
    if (d < 60)
      return "刚刚";
    if (d < 60 * 60)
      return Math.floor(d / 60) + "分钟前";
    if (i === t.getFullYear() && a === t.getMonth() + 1 && s === t.getDate())
      return `${f(l)}:${f(c)}`;
    return `${i}-${f(a)}-${f(s)}`;
    function f(R) {
      return R < 10 ? "0" + R : R;
    }
  }
}, sr = {
  // https://stackoverflow.com/questions/1573053/javascript-function-to-convert-color-names-to-hex-codes
  colorToRGBA: (e) => {
    let t = document.createElement("canvas");
    t.height = 1, t.width = 1;
    let n = t.getContext("2d");
    return n ? (n.fillStyle = e, n.fillRect(0, 0, 1, 1), n.getImageData(0, 0, 1, 1).data) : [];
  },
  byteToHex: (e) => ("0" + e.toString(16)).slice(-2),
  colorToHex: (e) => {
    var t, n;
    return t = sr.colorToRGBA(e), n = [0, 1, 2].map(
      function(r) {
        return sr.byteToHex(t[r]);
      }
    ).join(""), "#" + n;
  }
};
let Sn = !1, vn = 0, Vt = /* @__PURE__ */ new Map();
const ct = Ia.create({
  timeout: 6e4
});
ct.defaults.headers.post["content-type"] = "application/json";
ct.defaults.headers.delete["content-type"] = "application/json";
ct.defaults.headers.put["content-type"] = "application/json";
ct.defaults.headers.patch["content-type"] = "application/json";
const me = {
  requestWithoutAction: async (e) => {
    me.addRequiredHeaders();
    try {
      return (await ct(e)).data;
    } catch (t) {
      console.error(t);
    }
  },
  dispathAction: (e, t, n) => {
    const r = {
      type: t,
      data: e
    };
    n.dispatch(r);
  },
  requestWithActionType: (e, t, n) => {
    const r = {
      "x-action": t
    };
    return e.headers = Object.assign({}, e.headers, r), me.addRequiredHeaders(n), ct(e).then((o) => {
      const i = o.data, a = i.result, s = Ot.responseSuccess(i), c = {
        type: s ? t : "ERROR_BROADCAST",
        data: s ? a : i
      };
      return n.dispatch(c), i;
    }).catch((o) => {
      console.error(o);
    });
  },
  handleRefreshTokenExpire(e) {
    (e.data.resultCode === ze.REFRESH_TOKEN_EXPIRED || e.data.resultCode === ze.REFRESH_TOKEN_INVALID) && (window.location.href = "/login");
  },
  handleExpire: (e, t) => {
    const n = e.config, r = `${(n == null ? void 0 : n.baseURL) ?? ""} ${(n == null ? void 0 : n.url) ?? ""} ${new URLSearchParams(n == null ? void 0 : n.params).toString()}`;
    Sn && (Vt.has(r) || Vt.set(r, n)), !Sn && vn <= 3 && (e.data.resultCode === ze.ACCESS_TOKEN_EXPIRED || e.data.resultCode === ze.ACCESS_TOKEN_INVALID || e.status == 401 || e.status == 440) && (Vt.has(r) || Vt.set(r, n), Sn = !0, vn = vn + 1, Ke.handleWebAccessTokenExpire().then((o) => {
      if (!Ot.responseSuccess(o)) {
        window.location.href = "/user/login";
        return;
      }
      Sn = !1, vn = 0, Vt.forEach((i, a) => {
        const s = localStorage.getItem(
          Z.ACCESS_TOKEN_NAME
        );
        i.headers.Authorization = "Bearer " + s, i.headers["x-request-id"] = un(), ct(i).then((l) => {
          if (!t)
            return;
          const c = e.config.headers["x-action"];
          if (c) {
            const d = l.data.result, f = {
              type: c,
              data: d
            };
            t.dispatch(f);
          }
        });
      }), Vt.clear();
    }));
  },
  requestWithAction: (e, t, n) => {
    const o = {
      "x-action": t({}).type
    };
    return e.headers = Object.assign({}, e.headers, o), me.addRequiredHeaders(n), ct(e).then((i) => {
      const a = i.data.result;
      return n.dispatch(t(a)), i.data;
    }).catch((i) => {
      console.error(i);
    });
  },
  addRequiredHeaders: (e) => {
    ct.interceptors.request.use(
      (t) => {
        const n = localStorage.getItem(Z.ACCESS_TOKEN_NAME);
        return n && (t.headers.Authorization = "Bearer " + n), t.headers["x-request-id"] = un(), t;
      },
      (t) => Promise.reject(t)
    ), ct.interceptors.response.use(
      (t) => (me.handleExpire(t, e), me.handleRefreshTokenExpire(t), t),
      (t) => {
        var n, r;
        return (((n = t.response) == null ? void 0 : n.status) === 401 || ((r = t.response) == null ? void 0 : r.status) === 440) && me.handleExpire(t.response, e), Promise.reject(t);
      }
    );
  }
};
function Ja(e) {
  const t = {
    method: "get",
    url: "/infra/goods/list",
    headers: { "Content-Type": "application/json" }
  };
  return me.requestWithAction(t, oi, e);
}
function yo(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = yo(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function bt() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = yo(e)) && (r && (r += " "), r += t);
  return r;
}
const on = (e) => typeof e == "number" && !isNaN(e), Ft = (e) => typeof e == "string", Me = (e) => typeof e == "function", Tn = (e) => Ft(e) || Me(e) ? e : null, Yn = (e) => Xt(e) || Ft(e) || Me(e) || on(e);
function xa(e, t, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: r, style: o } = e;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = r + "px", o.transition = `all ${n}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(t, n);
    });
  });
}
function xn(e) {
  let { enter: t, exit: n, appendPosition: r = !1, collapse: o = !0, collapseDuration: i = 300 } = e;
  return function(a) {
    let { children: s, position: l, preventExitTransition: c, done: d, nodeRef: f, isIn: R } = a;
    const p = r ? `${t}--${l}` : t, h = r ? `${n}--${l}` : n, g = _e(0);
    return Ko(() => {
      const v = f.current, E = p.split(" "), w = (D) => {
        D.target === f.current && (v.dispatchEvent(new Event("d")), v.removeEventListener("animationend", w), v.removeEventListener("animationcancel", w), g.current === 0 && D.type !== "animationcancel" && v.classList.remove(...E));
      };
      v.classList.add(...E), v.addEventListener("animationend", w), v.addEventListener("animationcancel", w);
    }, []), Ht(() => {
      const v = f.current, E = () => {
        v.removeEventListener("animationend", E), o ? xa(v, d, i) : d();
      };
      R || (c ? E() : (g.current = 1, v.className += ` ${h}`, v.addEventListener("animationend", E)));
    }, [R]), re.createElement(re.Fragment, null, s);
  };
}
function Jr(e, t) {
  return e != null ? { content: e.content, containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, status: t } : {};
}
const Qe = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(e, t) {
  return this.list.has(e) || this.list.set(e, []), this.list.get(e).push(t), this;
}, off(e, t) {
  if (t) {
    const n = this.list.get(e).filter((r) => r !== t);
    return this.list.set(e, n), this;
  }
  return this.list.delete(e), this;
}, cancelEmit(e) {
  const t = this.emitQueue.get(e);
  return t && (t.forEach(clearTimeout), this.emitQueue.delete(e)), this;
}, emit(e) {
  this.list.has(e) && this.list.get(e).forEach((t) => {
    const n = setTimeout(() => {
      t(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(e) || this.emitQueue.set(e, []), this.emitQueue.get(e).push(n);
  });
} }, Rn = (e) => {
  let { theme: t, type: n, ...r } = e;
  return re.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...r });
}, Xn = { info: function(e) {
  return re.createElement(Rn, { ...e }, re.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(e) {
  return re.createElement(Rn, { ...e }, re.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(e) {
  return re.createElement(Rn, { ...e }, re.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(e) {
  return re.createElement(Rn, { ...e }, re.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return re.createElement("div", { className: "Toastify__spinner" });
} };
function Fa(e) {
  const [, t] = Xo((p) => p + 1, 0), [n, r] = gt([]), o = _e(null), i = _e(/* @__PURE__ */ new Map()).current, a = (p) => n.indexOf(p) !== -1, s = _e({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: e, containerId: null, isToastActive: a, getToast: (p) => i.get(p) }).current;
  function l(p) {
    let { containerId: h } = p;
    const { limit: g } = s.props;
    !g || h && s.containerId !== h || (s.count -= s.queue.length, s.queue = []);
  }
  function c(p) {
    r((h) => p == null ? [] : h.filter((g) => g !== p));
  }
  function d() {
    const { toastContent: p, toastProps: h, staleId: g } = s.queue.shift();
    R(p, h, g);
  }
  function f(p, h) {
    let { delay: g, staleId: v, ...E } = h;
    if (!Yn(p) || function(J) {
      return !o.current || s.props.enableMultiContainer && J.containerId !== s.props.containerId || i.has(J.toastId) && J.updateId == null;
    }(E))
      return;
    const { toastId: w, updateId: D, data: B } = E, { props: U } = s, $ = () => c(w), se = D == null;
    se && s.count++;
    const H = { ...U, style: U.toastStyle, key: s.toastKey++, ...Object.fromEntries(Object.entries(E).filter((J) => {
      let [te, N] = J;
      return N != null;
    })), toastId: w, updateId: D, data: B, closeToast: $, isIn: !1, className: Tn(E.className || U.toastClassName), bodyClassName: Tn(E.bodyClassName || U.bodyClassName), progressClassName: Tn(E.progressClassName || U.progressClassName), autoClose: !E.isLoading && (de = E.autoClose, Y = U.autoClose, de === !1 || on(de) && de > 0 ? de : Y), deleteToast() {
      const J = Jr(i.get(w), "removed");
      i.delete(w), Qe.emit(4, J);
      const te = s.queue.length;
      if (s.count = w == null ? s.count - s.displayedToast : s.count - 1, s.count < 0 && (s.count = 0), te > 0) {
        const N = w == null ? s.props.limit : 1;
        if (te === 1 || N === 1)
          s.displayedToast++, d();
        else {
          const b = N > te ? te : N;
          s.displayedToast = b;
          for (let I = 0; I < b; I++)
            d();
        }
      } else
        t();
    } };
    var de, Y;
    H.iconOut = function(J) {
      let { theme: te, type: N, isLoading: b, icon: I } = J, O = null;
      const A = { theme: te, type: N };
      return I === !1 || (Me(I) ? O = I(A) : Xt(I) ? O = tr(I, A) : Ft(I) || on(I) ? O = I : b ? O = Xn.spinner() : ((x) => x in Xn)(N) && (O = Xn[N](A))), O;
    }(H), Me(E.onOpen) && (H.onOpen = E.onOpen), Me(E.onClose) && (H.onClose = E.onClose), H.closeButton = U.closeButton, E.closeButton === !1 || Yn(E.closeButton) ? H.closeButton = E.closeButton : E.closeButton === !0 && (H.closeButton = !Yn(U.closeButton) || U.closeButton);
    let G = p;
    Xt(p) && !Ft(p.type) ? G = tr(p, { closeToast: $, toastProps: H, data: B }) : Me(p) && (G = p({ closeToast: $, toastProps: H, data: B })), U.limit && U.limit > 0 && s.count > U.limit && se ? s.queue.push({ toastContent: G, toastProps: H, staleId: v }) : on(g) ? setTimeout(() => {
      R(G, H, v);
    }, g) : R(G, H, v);
  }
  function R(p, h, g) {
    const { toastId: v } = h;
    g && i.delete(g);
    const E = { content: p, props: h };
    i.set(v, E), r((w) => [...w, v].filter((D) => D !== g)), Qe.emit(4, Jr(E, E.props.updateId == null ? "added" : "updated"));
  }
  return Ht(() => (s.containerId = e.containerId, Qe.cancelEmit(3).on(0, f).on(1, (p) => o.current && c(p)).on(5, l).emit(2, s), () => {
    i.clear(), Qe.emit(3, s);
  }), []), Ht(() => {
    s.props = e, s.isToastActive = a, s.displayedToast = n.length;
  }), { getToastToRender: function(p) {
    const h = /* @__PURE__ */ new Map(), g = Array.from(i.values());
    return e.newestOnTop && g.reverse(), g.forEach((v) => {
      const { position: E } = v.props;
      h.has(E) || h.set(E, []), h.get(E).push(v);
    }), Array.from(h, (v) => p(v[0], v[1]));
  }, containerRef: o, isToastActive: a };
}
function xr(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function Fr(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function Ma(e) {
  const [t, n] = gt(!1), [r, o] = gt(!1), i = _e(null), a = _e({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, s = _e(e), { autoClose: l, pauseOnHover: c, closeToast: d, onClick: f, closeOnClick: R } = e;
  function p(B) {
    if (e.draggable) {
      B.nativeEvent.type === "touchstart" && B.nativeEvent.preventDefault(), a.didMove = !1, document.addEventListener("mousemove", E), document.addEventListener("mouseup", w), document.addEventListener("touchmove", E), document.addEventListener("touchend", w);
      const U = i.current;
      a.canCloseOnClick = !0, a.canDrag = !0, a.boundingRect = U.getBoundingClientRect(), U.style.transition = "", a.x = xr(B.nativeEvent), a.y = Fr(B.nativeEvent), e.draggableDirection === "x" ? (a.start = a.x, a.removalDistance = U.offsetWidth * (e.draggablePercent / 100)) : (a.start = a.y, a.removalDistance = U.offsetHeight * (e.draggablePercent === 80 ? 1.5 * e.draggablePercent : e.draggablePercent / 100));
    }
  }
  function h(B) {
    if (a.boundingRect) {
      const { top: U, bottom: $, left: se, right: H } = a.boundingRect;
      B.nativeEvent.type !== "touchend" && e.pauseOnHover && a.x >= se && a.x <= H && a.y >= U && a.y <= $ ? v() : g();
    }
  }
  function g() {
    n(!0);
  }
  function v() {
    n(!1);
  }
  function E(B) {
    const U = i.current;
    a.canDrag && U && (a.didMove = !0, t && v(), a.x = xr(B), a.y = Fr(B), a.delta = e.draggableDirection === "x" ? a.x - a.start : a.y - a.start, a.start !== a.x && (a.canCloseOnClick = !1), U.style.transform = `translate${e.draggableDirection}(${a.delta}px)`, U.style.opacity = "" + (1 - Math.abs(a.delta / a.removalDistance)));
  }
  function w() {
    document.removeEventListener("mousemove", E), document.removeEventListener("mouseup", w), document.removeEventListener("touchmove", E), document.removeEventListener("touchend", w);
    const B = i.current;
    if (a.canDrag && a.didMove && B) {
      if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance)
        return o(!0), void e.closeToast();
      B.style.transition = "transform 0.2s, opacity 0.2s", B.style.transform = `translate${e.draggableDirection}(0)`, B.style.opacity = "1";
    }
  }
  Ht(() => {
    s.current = e;
  }), Ht(() => (i.current && i.current.addEventListener("d", g, { once: !0 }), Me(e.onOpen) && e.onOpen(Xt(e.children) && e.children.props), () => {
    const B = s.current;
    Me(B.onClose) && B.onClose(Xt(B.children) && B.children.props);
  }), []), Ht(() => (e.pauseOnFocusLoss && (document.hasFocus() || v(), window.addEventListener("focus", g), window.addEventListener("blur", v)), () => {
    e.pauseOnFocusLoss && (window.removeEventListener("focus", g), window.removeEventListener("blur", v));
  }), [e.pauseOnFocusLoss]);
  const D = { onMouseDown: p, onTouchStart: p, onMouseUp: h, onTouchEnd: h };
  return l && c && (D.onMouseEnter = v, D.onMouseLeave = g), R && (D.onClick = (B) => {
    f && f(B), a.canCloseOnClick && d();
  }), { playToast: g, pauseToast: v, isRunning: t, preventExitTransition: r, toastRef: i, eventHandlers: D };
}
function Ao(e) {
  let { closeToast: t, theme: n, ariaLabel: r = "close" } = e;
  return re.createElement("button", { className: `Toastify__close-button Toastify__close-button--${n}`, type: "button", onClick: (o) => {
    o.stopPropagation(), t(o);
  }, "aria-label": r }, re.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, re.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function Wa(e) {
  let { delay: t, isRunning: n, closeToast: r, type: o = "default", hide: i, className: a, style: s, controlledProgress: l, progress: c, rtl: d, isIn: f, theme: R } = e;
  const p = i || l && c === 0, h = { ...s, animationDuration: `${t}ms`, animationPlayState: n ? "running" : "paused", opacity: p ? 0 : 1 };
  l && (h.transform = `scaleX(${c})`);
  const g = bt("Toastify__progress-bar", l ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${R}`, `Toastify__progress-bar--${o}`, { "Toastify__progress-bar--rtl": d }), v = Me(a) ? a({ rtl: d, type: o, defaultClassName: g }) : bt(g, a);
  return re.createElement("div", { role: "progressbar", "aria-hidden": p ? "true" : "false", "aria-label": "notification timer", className: v, style: h, [l && c >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: l && c < 1 ? null : () => {
    f && r();
  } });
}
const Ua = (e) => {
  const { isRunning: t, preventExitTransition: n, toastRef: r, eventHandlers: o } = Ma(e), { closeButton: i, children: a, autoClose: s, onClick: l, type: c, hideProgressBar: d, closeToast: f, transition: R, position: p, className: h, style: g, bodyClassName: v, bodyStyle: E, progressClassName: w, progressStyle: D, updateId: B, role: U, progress: $, rtl: se, toastId: H, deleteToast: de, isIn: Y, isLoading: G, iconOut: J, closeOnClick: te, theme: N } = e, b = bt("Toastify__toast", `Toastify__toast-theme--${N}`, `Toastify__toast--${c}`, { "Toastify__toast--rtl": se }, { "Toastify__toast--close-on-click": te }), I = Me(h) ? h({ rtl: se, position: p, type: c, defaultClassName: b }) : bt(b, h), O = !!$ || !s, A = { closeToast: f, type: c, theme: N };
  let x = null;
  return i === !1 || (x = Me(i) ? i(A) : Xt(i) ? tr(i, A) : Ao(A)), re.createElement(R, { isIn: Y, done: de, position: p, preventExitTransition: n, nodeRef: r }, re.createElement("div", { id: H, onClick: l, className: I, ...o, style: g, ref: r }, re.createElement("div", { ...Y && { role: U }, className: Me(v) ? v({ type: c }) : bt("Toastify__toast-body", v), style: E }, J != null && re.createElement("div", { className: bt("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !G }) }, J), re.createElement("div", null, a)), x, re.createElement(Wa, { ...B && !O ? { key: `pb-${B}` } : {}, rtl: se, theme: N, delay: s, isRunning: t, isIn: Y, closeToast: f, hide: d, type: c, style: D, className: w, controlledProgress: O, progress: $ || 0 })));
}, Fn = function(e, t) {
  return t === void 0 && (t = !1), { enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: t };
}, Ga = xn(Fn("bounce", !0));
xn(Fn("slide", !0));
xn(Fn("zoom"));
xn(Fn("flip"));
const Cn = Yo((e, t) => {
  const { getToastToRender: n, containerRef: r, isToastActive: o } = Fa(e), { className: i, style: a, rtl: s, containerId: l } = e;
  function c(d) {
    const f = bt("Toastify__toast-container", `Toastify__toast-container--${d}`, { "Toastify__toast-container--rtl": s });
    return Me(i) ? i({ position: d, rtl: s, defaultClassName: f }) : bt(f, Tn(i));
  }
  return Ht(() => {
    t && (t.current = r.current);
  }, []), re.createElement("div", { ref: r, className: "Toastify", id: l }, n((d, f) => {
    const R = f.length ? { ...a } : { ...a, pointerEvents: "none" };
    return re.createElement("div", { className: c(d), style: R, key: `container-${d}` }, f.map((p, h) => {
      let { content: g, props: v } = p;
      return re.createElement(Ua, { ...v, isIn: o(v.toastId), style: { ...v.style, "--nth": h + 1, "--len": f.length }, key: `toast-${v.key}` }, g);
    }));
  }));
});
Cn.displayName = "ToastContainer", Cn.defaultProps = { position: "top-right", transition: Ga, autoClose: 5e3, closeButton: Ao, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let Kn, Nt = /* @__PURE__ */ new Map(), rn = [], za = 1;
function wo() {
  return "" + za++;
}
function Va(e) {
  return e && (Ft(e.toastId) || on(e.toastId)) ? e.toastId : wo();
}
function an(e, t) {
  return Nt.size > 0 ? Qe.emit(0, e, t) : rn.push({ content: e, options: t }), t.toastId;
}
function Dn(e, t) {
  return { ...t, type: t && t.type || e, toastId: Va(t) };
}
function In(e) {
  return (t, n) => an(t, Dn(e, n));
}
function q(e, t) {
  return an(e, Dn("default", t));
}
q.loading = (e, t) => an(e, Dn("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t })), q.promise = function(e, t, n) {
  let r, { pending: o, error: i, success: a } = t;
  o && (r = Ft(o) ? q.loading(o, n) : q.loading(o.render, { ...n, ...o }));
  const s = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, l = (d, f, R) => {
    if (f == null)
      return void q.dismiss(r);
    const p = { type: d, ...s, ...n, data: R }, h = Ft(f) ? { render: f } : f;
    return r ? q.update(r, { ...p, ...h }) : q(h.render, { ...p, ...h }), R;
  }, c = Me(e) ? e() : e;
  return c.then((d) => l("success", a, d)).catch((d) => l("error", i, d)), c;
}, q.success = In("success"), q.info = In("info"), q.error = In("error"), q.warning = In("warning"), q.warn = q.warning, q.dark = (e, t) => an(e, Dn("default", { theme: "dark", ...t })), q.dismiss = (e) => {
  Nt.size > 0 ? Qe.emit(1, e) : rn = rn.filter((t) => e != null && t.options.toastId !== e);
}, q.clearWaitingQueue = function(e) {
  return e === void 0 && (e = {}), Qe.emit(5, e);
}, q.isActive = (e) => {
  let t = !1;
  return Nt.forEach((n) => {
    n.isToastActive && n.isToastActive(e) && (t = !0);
  }), t;
}, q.update = function(e, t) {
  t === void 0 && (t = {}), setTimeout(() => {
    const n = function(r, o) {
      let { containerId: i } = o;
      const a = Nt.get(i || Kn);
      return a && a.getToast(r);
    }(e, t);
    if (n) {
      const { props: r, content: o } = n, i = { delay: 100, ...r, ...t, toastId: t.toastId || e, updateId: wo() };
      i.toastId !== e && (i.staleId = e);
      const a = i.render || o;
      delete i.render, an(a, i);
    }
  }, 0);
}, q.done = (e) => {
  q.update(e, { progress: 1 });
}, q.onChange = (e) => (Qe.on(4, e), () => {
  Qe.off(4, e);
}), q.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, q.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, Qe.on(2, (e) => {
  Kn = e.containerId || e, Nt.set(Kn, e), rn.forEach((t) => {
    Qe.emit(0, t.content, t.options);
  }), rn = [];
}).on(3, (e) => {
  Nt.delete(e.containerId || e), Nt.size === 0 && Qe.off(0).off(1).off(5);
});
var Lt = /* @__PURE__ */ ((e) => (e[e.CREATE_ORDER = 0] = "CREATE_ORDER", e[e.CLEAR_ALIPAY_FORM_TEXT = 1] = "CLEAR_ALIPAY_FORM_TEXT", e[e.SET_PAYED_ORDER_INFO = 2] = "SET_PAYED_ORDER_INFO", e))(Lt || {});
const Mr = {
  doPay: (e, t) => {
    const n = {
      method: "post",
      url: "/infra/alipay/pay/createOrder",
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(e)
    }, r = Lt[Lt.CREATE_ORDER];
    return me.requestWithActionType(n, r, t);
  },
  setPayedInfo: (e, t) => {
    const r = {
      type: Lt[Lt.SET_PAYED_ORDER_INFO],
      data: e
    };
    t.dispatch(r);
  },
  doClearAlipayFormText: (e) => {
    const n = {
      type: Lt[Lt.CLEAR_ALIPAY_FORM_TEXT],
      data: ""
    };
    e.dispatch(n);
  }
}, qa = (e) => ({}), Za = (e) => ({}), Ya = Qo(qa, Za);
const Xa = (e) => {
  const t = e.payFormText, n = e.price, r = e.payProvider, o = (i) => {
    const a = document.getElementById("pay-mask");
    a && (a.style.display = i);
    const s = document.getElementById("pay-popup");
    s && (s.style.display = i);
  };
  return t && t.length > 0 ? o("block") : o("none"), /* @__PURE__ */ T.jsxs("div", { children: [
    /* @__PURE__ */ T.jsx("div", { id: "pay-mask", className: "pay-mask" }),
    /* @__PURE__ */ T.jsx("div", { id: "pay-popup", className: "pay-pop", children: /* @__PURE__ */ T.jsxs("div", { className: "pay-container", id: "main", children: [
      /* @__PURE__ */ T.jsxs("div", { className: "pay-money", children: [
        "支付金额  ",
        /* @__PURE__ */ T.jsxs("span", { id: "pay_price", children: [
          n,
          "元"
        ] })
      ] }),
      /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx("div", { className: "pay-img", children: /* @__PURE__ */ T.jsx(
        "iframe",
        {
          srcDoc: t,
          width: "200",
          height: "205"
        }
      ) }) }),
      /* @__PURE__ */ T.jsxs("p", { className: "pay-paragraph", children: [
        /* @__PURE__ */ T.jsx(
          "img",
          {
            className: "pay-scan",
            src: "/addons/zzzy_idcard_pc/core/web/statics/images/site/icon-wechat.png",
            alt: ""
          }
        ),
        r,
        "扫码支付"
      ] }),
      /* @__PURE__ */ T.jsx("div", { className: "pay-complete-action", children: /* @__PURE__ */ T.jsx("button", { className: "pay-complete-btn", onClick: e.onPayComplete, children: "支付完成" }) })
    ] }) })
  ] });
};
var Pt = /* @__PURE__ */ ((e) => (e[e.GET_ORDER_STATUS = 0] = "GET_ORDER_STATUS", e[e.GET_ORDER = 1] = "GET_ORDER", e[e.GET_ORDER_LIST = 2] = "GET_ORDER_LIST", e[e.GET_ORDER_PAGE = 3] = "GET_ORDER_PAGE", e))(Pt || {});
const Ka = {
  getOrderStatus: (e, t) => {
    const n = {
      method: "get",
      url: "/infra/order/status?orderId=" + e
    }, r = Pt[Pt.GET_ORDER_STATUS];
    return me.requestWithActionType(n, r, t);
  },
  getUserOrderList: (e) => {
    const t = {
      method: "get",
      url: "/infra/order/list"
    }, n = Pt[Pt.GET_ORDER_LIST];
    return me.requestWithActionType(t, n, e);
  },
  getUserOrderPage: (e, t) => {
    const n = new URLSearchParams();
    for (const [i, a] of Object.entries(t))
      n.append(i, a);
    const r = {
      method: "get",
      url: "/infra/order/page",
      params: n
    }, o = Pt[Pt.GET_ORDER_PAGE];
    return me.requestWithActionType(r, o, e);
  }
};
var Le = /* @__PURE__ */ ((e) => (e[e.LOGIN_BY_PHONE = 0] = "LOGIN_BY_PHONE", e[e.USER_LOGIN = 1] = "USER_LOGIN", e[e.GET_CURRENT_USER = 2] = "GET_CURRENT_USER", e[e.USER_REG = 3] = "USER_REG", e[e.SEND_VERIFY_CODE = 4] = "SEND_VERIFY_CODE", e[e.RESET_PWD = 5] = "RESET_PWD", e[e.USER_UNBIND = 6] = "USER_UNBIND", e[e.SET_NICKNAME = 7] = "SET_NICKNAME", e))(Le || {});
const Jt = {
  getCurrentUser: (e) => {
    const t = {
      method: "get",
      url: "/infra/user/current-user"
    }, n = Le[Le.GET_CURRENT_USER];
    return me.requestWithActionType(t, n, e);
  },
  getCurrUser: (e) => {
    const t = {
      method: "get",
      url: e
    };
    return me.requestWithoutAction(t);
  },
  userLoginImpl: (e, t, n) => {
    const r = {
      method: "get",
      url: n,
      params: e
    }, o = Le[Le.USER_LOGIN];
    return me.requestWithActionType(r, o, t);
  },
  userLoginByPhoneImpl: (e, t, n) => {
    const r = {
      method: "post",
      url: n,
      data: JSON.stringify(e)
    }, o = Le[Le.LOGIN_BY_PHONE];
    return me.requestWithActionType(r, o, t);
  },
  isLoggedIn: () => localStorage.getItem(Z.ACCESS_TOKEN_NAME) != null,
  isSubscribed: () => {
    const e = localStorage.getItem("userInfo");
    if (!e)
      return !1;
    const t = JSON.parse(e);
    return !!(t && Number(t.autoRenewProductExpireTimeMs) > (/* @__PURE__ */ new Date()).getTime());
  },
  doLoginOut: (e) => {
    localStorage.removeItem("isLoggedIn"), localStorage.removeItem(Z.ACCESS_TOKEN_NAME), localStorage.removeItem(Z.REFRESH_TOKEN_NAME), localStorage.removeItem("avatarUrl"), localStorage.removeItem("userInfo"), localStorage.removeItem("base-auth-url"), localStorage.removeItem("access-token-url-path"), document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;", document.cookie = "avatarUrl=; expires=Thu, 01 Jan 1970 00:00:01 GMT;", document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;", window.location.href = e;
  },
  userReg: (e, t, n) => {
    const r = {
      method: "post",
      url: n,
      data: JSON.stringify(e)
    }, o = Le[Le.USER_REG];
    return me.requestWithActionType(r, o, t);
  },
  doSendVerifyCode: (e, t, n) => {
    const r = {
      method: "post",
      url: t,
      data: JSON.stringify(e)
    }, o = Le[Le.SEND_VERIFY_CODE];
    return me.requestWithActionType(r, o, n);
  },
  doResetPwd: (e, t, n) => {
    const r = {
      method: "patch",
      url: t,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(e)
    }, o = Le[Le.RESET_PWD];
    return me.requestWithActionType(r, o, n);
  },
  doSetNickname: (e, t, n) => {
    const r = {
      method: "patch",
      url: t,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(e)
    }, o = Le[Le.SET_NICKNAME];
    return me.requestWithActionType(r, o, n);
  },
  getCurrLang: () => {
    const e = navigator.language, t = localStorage.getItem("userLanguage");
    return t || e;
  },
  userUnbind: (e, t, n) => {
    const r = {
      method: "delete",
      url: t + "?accountType=" + e
    }, o = Le[Le.USER_UNBIND];
    return me.requestWithActionType(r, o, n);
  },
  loadCurrUser: async (e, t) => {
    let n = {
      nickname: "unkown",
      autoRenewProductExpireTimeMs: 0,
      thirdBind: []
    };
    if (e) {
      let r = await Jt.getCurrUser(t);
      if (Ot.responseSuccess(r)) {
        const o = r.result.userId;
        o && (localStorage.setItem("userInfo", JSON.stringify(r.result)), n = o);
      }
    } else {
      const r = localStorage.getItem("userInfo");
      if (r)
        return JSON.parse(r);
      let o = await Jt.getCurrUser(t);
      if (Ot.responseSuccess(o)) {
        const i = o.result.userId;
        i && (localStorage.setItem("userInfo", JSON.stringify(o.result)), n = i);
      }
    }
    return n;
  }
}, bo = (e) => {
  const { iapproducts: t } = Ar((E) => E.rdRootReducer.iapproduct), { createdOrder: n } = Ar((E) => E.rdRootReducer.pay), [r, o] = gt(""), [i, a] = gt(), [s, l] = gt([]), [c, d] = gt();
  re.useEffect(() => (R(), document.addEventListener("click", f), () => {
    document.removeEventListener("click", f);
  }), []), re.useEffect(() => {
    t && t.length > 0 && l(t);
  }, [t]), re.useEffect(() => (n && Object.keys(n).length > 0 && (a(n), o(n.formText)), () => {
    Mr.doClearAlipayFormText(e.store);
  }), [n]);
  const f = (E) => {
    const w = document.getElementById("pay-popup");
    w && !w.contains(E.target) && o("");
  }, R = () => {
    Ja(e.store);
  }, p = (E) => {
    let w = {
      productId: Number(E.id)
    };
    d(E), Mr.doPay(w, e.store);
  }, h = (E) => {
    if (Ro.isNull(E))
      return /* @__PURE__ */ T.jsx("div", {});
    const w = [];
    return E.sort((D, B) => B.sort - D.sort).forEach((D) => {
      w.push(
        /* @__PURE__ */ T.jsxs("div", { className: hn.package, children: [
          /* @__PURE__ */ T.jsx("h2", { children: D.productTitle }),
          /* @__PURE__ */ T.jsxs("p", { className: hn.price, children: [
            D.price,
            /* @__PURE__ */ T.jsx("span", { children: "元" })
          ] }),
          /* @__PURE__ */ T.jsx("ul", { children: g(D.description) }),
          /* @__PURE__ */ T.jsx("button", { onClick: () => p(D), children: "立即订阅" })
        ] }, un())
      );
    }), w;
  }, g = (E) => {
    const w = JSON.parse(E);
    if (w) {
      const D = [];
      return w.forEach((B) => {
        D.push(/* @__PURE__ */ T.jsx("li", { children: B }, un()));
      }), D;
    }
  }, v = () => {
    if (!i || !i.orderId) {
      q.error("未找到订单信息");
      return;
    }
    const E = i.orderId;
    Ka.getOrderStatus(E, e.store).then((w) => {
      if (Ot.responseSuccess(w))
        if (Number(w.result.orderStatus) === 1) {
          if (o(""), a(void 0), !e.refreshUrl || e.refreshUrl.length === 0)
            return;
          Jt.loadCurrUser(!0, e.refreshUrl), Ke.handleWebAccessTokenExpire();
        } else
          q.warning("检测到订单当前未支付，请稍后再次确认");
      else
        q.warning("订单检测失败");
    });
  };
  return /* @__PURE__ */ T.jsxs("div", { children: [
    /* @__PURE__ */ T.jsx("div", { className: hn.container, children: h(s) }),
    /* @__PURE__ */ T.jsx("div", { className: hn.goodsDivider }),
    /* @__PURE__ */ T.jsx(Xa, { payFormText: r, price: c == null ? void 0 : c.price, payProvider: "支付宝", onPayComplete: v })
  ] });
};
bo.defaultProps = {
  refreshUrl: ""
};
const Gu = Ya(bo), Qa = {
  createdOrder: {},
  order: {}
}, _a = (e = Qa, t) => {
  switch (t.type) {
    case "CREATE_ORDER":
      return {
        ...e,
        createdOrder: t.data
      };
    case "CLEAR_ALIPAY_FORM_TEXT":
      return {
        ...e,
        createdOrder: ""
      };
    case "SET_PAYED_ORDER_INFO":
      return {
        ...e,
        order: t.data
      };
  }
  return e;
}, $a = {
  iapproducts: {}
}, es = (e = $a, t) => {
  switch (t.type) {
    case "GET_IAP_PRODUCT":
      return {
        ...e,
        iapproducts: t.data ? t.data : {}
      };
  }
  return e;
}, ts = {
  user: {},
  loginUser: {}
}, ns = (e = ts, t) => {
  switch (t.type) {
    case "GET_CURRENT_USER":
      return {
        ...e,
        user: t.data
      };
    case "USER_UNBIND":
      return {
        ...e,
        user: t.data
      };
    case "LOGIN_BY_PHONE":
      return {
        ...e,
        loginUser: t.data
      };
  }
  return e;
}, rs = {
  file: {},
  downloadfile: {},
  rembgfile: {}
}, os = (e = rs, t) => {
  switch (t.type) {
    case "UPLOAD_FILE":
      return {
        ...e,
        file: t.data
      };
    case "DOWNLOAD_FILE":
      return {
        ...e,
        downloadfile: t.data
      };
    case "FILE_CLEAR":
      return {
        ...e,
        file: {},
        rembgfile: {},
        downloadfile: {}
      };
    case "FILE_REMOVE_BG":
      return {
        ...e,
        rembgfile: t.data
      };
  }
  return e;
}, is = {
  order: {},
  orderList: [],
  orderPage: {}
}, as = (e = is, t) => {
  switch (t.type) {
    case "GET_ORDER_STATUS":
      return {
        ...e,
        order: t.data
      };
    case "GET_ORDER_LIST":
      return {
        ...e,
        orderList: t.data
      };
    case "GET_ORDER_PAGE":
      return {
        ...e,
        orderPage: t.data
      };
  }
  return e;
}, ss = {
  errors: {}
}, cs = (e = ss, t) => {
  switch (t.type) {
    case "ERROR_BROADCAST":
      return {
        ...e,
        errors: t.data
      };
  }
  return e;
}, zu = _o({
  pay: _a,
  iapproduct: es,
  user: ns,
  file: os,
  order: as,
  sys: cs
}), Vu = () => /* @__PURE__ */ T.jsx("div", { children: "Demo Page func" }), qu = () => /* @__PURE__ */ T.jsx("div", { children: "Demo Page con" });
const us = "data:image/webp;base64,UklGRg4CAABXRUJQVlA4WAoAAAAQAAAAEwAAEwAAQUxQSJYAAAABcFtr25q8J1UGoPwX4FAzAKmYIB0DpGKFLIGzgJfQuUMFE7i7O/F8jBAREwBzJnV7EoNtT+KuKIryzoo2eMX0oygKb8GqZsYcb+L8KLZnLoNbIRpYlVJggF8hy0CYFgAGtAGw/kueFgCatCrwps0BkSYAnHiwtxEAQFjbW5vkFGLKwAcuduYyZwAcvnijP5k08gEvBwBWUDggUgEAABAHAJ0BKhQAFAA+kT6aSSWjIiEoCqiwEglsAJ0yhHA3tfGd7NmQvtBdo28ieUATJoSgOg/MVTE2CkXNg98+ZY1wAPzVnOmz4oeB+Zpx9UxMCHv7eCY0Y5dm/1TZHF7v/Ni/FXrjUgai8+rPRv749KVFp0m3T+I1x/7ERu6VsiYD7i/uS7hnNa3WGLlrWqHLJp1m499vWulmyp+Th6r8/3BVANsG3lUpumkjoO3Fnft7h/T2FFkr+gbdGH8Zz2BKSVK30ADkdAG9vEXz95yi4exflMUHt5xDcWGA+3gDvbzL8vcBBvalNqkDbmYYqtZOI0IMnDuzaF4/X9JguT2SJ2grJgyPEzSUEQ3AslbBPWMsJr8W3pA5zOaS3avqjAIdU6jBl6rhm1bSykCQPK60q8GlX5yrLZlvlaqvmFDTHnnJBxyRjjry+NRzMRkIp3UudAAA", Zu = () => {
  let e = (/* @__PURE__ */ new Date()).toISOString().substr(0, 4);
  return /* @__PURE__ */ T.jsx("div", { className: "App-footer-float", children: /* @__PURE__ */ T.jsxs("div", { id: "footer", className: "App-footer", children: [
    /* @__PURE__ */ T.jsx("div", { className: "App-footer-divider" }),
    /* @__PURE__ */ T.jsx("div", { className: "custom-row", children: /* @__PURE__ */ T.jsxs("div", { className: "App-footer-div", children: [
      "©2021-",
      e,
      " RedDwarf 重庆红矮星科技有限公司 ",
      /* @__PURE__ */ T.jsx("a", { href: "http://beian.miit.gov.cn/", children: "渝ICP备2021003460号-1" }),
      " ",
      /* @__PURE__ */ T.jsx("a", { href: "mailto:jiangxiaoqiang@poemhub.top", children: "联系我们" })
    ] }) }),
    /* @__PURE__ */ T.jsx("div", { className: "custom-row", children: /* @__PURE__ */ T.jsxs("div", { className: "App-footer-div", children: [
      /* @__PURE__ */ T.jsx("img", { src: us }),
      /* @__PURE__ */ T.jsx("a", { href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50022502000614", children: " 渝公网安备 50022502000614 号" })
    ] }) })
  ] }) });
}, Yu = {
  getVipExpiredTime: (e) => {
    if (!e || !e.autoRenewProductExpireTimeMs)
      return "--";
    const t = Number(e.autoRenewProductExpireTimeMs);
    return t && t > (/* @__PURE__ */ new Date()).getTime() ? wt.getFormattedTime(t) : "--";
  }
};
var Bt = /* @__PURE__ */ ((e) => (e[e.UPLOAD_FILE = 0] = "UPLOAD_FILE", e[e.DOWNLOAD_FILE = 1] = "DOWNLOAD_FILE", e[e.FILE_CLEAR = 2] = "FILE_CLEAR", e[e.FILE_REMOVE_BG = 3] = "FILE_REMOVE_BG", e))(Bt || {});
const Xu = {
  send: async (e, t) => {
    switch (t) {
      case "info": {
        await q.info(e);
        break;
      }
      case "success": {
        await q.success(e);
        break;
      }
      case "error": {
        await q.error(e);
        break;
      }
      case "warning": {
        await q.warning(e);
        break;
      }
      case "loading": {
        await q.loading(e);
        break;
      }
      default: {
        await q.info(e);
        return;
      }
    }
  }
}, ls = "data:image/png;base64,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", ds = "_paySuccessBody_6sfj7_1", fs = "_paySuccessIndicator_6sfj7_6", ps = "_paySuccessTip_6sfj7_19", Qn = {
  paySuccessBody: ds,
  paySuccessIndicator: fs,
  paySuccessTip: ps
}, Ku = () => /* @__PURE__ */ T.jsxs("div", { className: Qn.paySuccessBody, children: [
  /* @__PURE__ */ T.jsx("div", { className: Qn.paySuccessIndicator, children: /* @__PURE__ */ T.jsx("img", { src: ls }) }),
  /* @__PURE__ */ T.jsx("div", { className: Qn.paySuccessTip, children: "支付成功" })
] }), Qu = {
  doUpload: (e, t, n) => {
    const r = {
      method: "post",
      url: t,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(e)
    }, o = Bt[Bt.UPLOAD_FILE];
    return me.requestWithActionType(r, o, n);
  },
  getDownloadFileUrl: (e, t, n) => {
    const o = {
      method: "get",
      url: "/snap/photo/download?" + new URLSearchParams({
        id: e,
        bgColor: t
      })
    }, i = Bt[Bt.DOWNLOAD_FILE];
    return me.requestWithActionType(o, i, n);
  },
  downloadZipFile: async (e) => {
    const t = {
      method: "get",
      responseType: "blob",
      headers: {
        "Content-Type": "application/octet-stream"
      },
      url: "/snap/photo/download/batch?" + e
    };
    return await me.requestWithoutAction(t);
  },
  clearPhoto: (e) => {
    const n = {
      type: Bt[Bt.FILE_CLEAR],
      data: null
    };
    e.dispatch(n);
  },
  downloadPhoto: (e, t) => {
    const n = document.getElementById(t);
    if (!n)
      return;
    const r = document.createElement("canvas");
    r.width = n.naturalWidth, r.height = n.naturalHeight;
    const o = r.getContext("2d");
    if (!o)
      return;
    o.imageSmoothingEnabled = !0, o.drawImage(n, 0, 0, r.width, r.height);
    const i = o.getImageData(0, 0, r.width, r.height);
    if (e !== "origin") {
      const l = i.data, c = sr.colorToRGBA(e);
      if (!c) {
        q.warning("不支持的背景色");
        return;
      }
      const d = c[0], f = c[1], R = c[2];
      for (let p = 0; p < l.length; p += 4) {
        const h = l[p], g = l[p + 1], v = l[p + 2], E = l[p + 3];
        h === 0 && g === 0 && v === 0 && E === 0 ? (l[p] = d, l[p + 1] = f, l[p + 2] = R, l[p + 3] = 255) : h < 160 && g < 160 && v < 160 && E === 0 && (l[p] = d, l[p + 1] = f, l[p + 2] = R, l[p + 3] = 0);
      }
    }
    o.putImageData(i, 0, 0);
    const a = r.toDataURL("image/png"), s = document.createElement("a");
    s.href = a, s.download = "image.png", s.click();
  },
  downloadPhotoLegacy: (e, t) => {
    const n = document.getElementById(t);
    if (!n)
      return;
    const r = document.createElement("canvas");
    r.width = n.naturalWidth, r.height = n.naturalHeight;
    const o = r.getContext("2d");
    if (!o)
      return;
    o.imageSmoothingEnabled = !0, o.drawImage(n, 0, 0, r.width, r.height);
    const i = o.getImageData(0, 0, r.width, r.height);
    e !== "origin" && (o.fillStyle = "#ff0000", o.globalCompositeOperation = "destination-over", o.fillRect(0, 0, r.width, r.height)), o.putImageData(i, 0, 0);
    const a = r.toDataURL("image/png"), s = document.createElement("a");
    s.href = a, s.download = "image.png", s.click();
  },
  saveBase64AsFile: (e, t) => {
    const r = ((a, s) => {
      const l = atob(a.split(",")[1]), c = new ArrayBuffer(l.length), d = new Uint8Array(c);
      for (let f = 0; f < l.length; f++)
        d[f] = l.charCodeAt(f);
      return new Blob([c], { type: s });
    })(e, "image/png"), o = URL.createObjectURL(r), i = document.createElement("a");
    i.href = o, i.download = t, i.click();
  }
};
var cr = { exports: {} };
/** @license
 * eventsource.js
 * Available under MIT License (MIT)
 * https://github.com/Yaffle/EventSource/
 */
(function(e, t) {
  (function(n) {
    var r = n.setTimeout, o = n.clearTimeout, i = n.XMLHttpRequest, a = n.XDomainRequest, s = n.ActiveXObject, l = n.EventSource, c = n.document, d = n.Promise, f = n.fetch, R = n.Response, p = n.TextDecoder, h = n.TextEncoder, g = n.AbortController;
    if (typeof window < "u" && typeof c < "u" && !("readyState" in c) && c.body == null && (c.readyState = "loading", window.addEventListener("load", function(m) {
      c.readyState = "complete";
    }, !1)), i == null && s != null && (i = function() {
      return new s("Microsoft.XMLHTTP");
    }), Object.create == null && (Object.create = function(m) {
      function C() {
      }
      return C.prototype = m, new C();
    }), Date.now || (Date.now = function() {
      return (/* @__PURE__ */ new Date()).getTime();
    }), g == null) {
      var v = f;
      f = function(m, C) {
        var j = C.signal;
        return v(m, { headers: C.headers, credentials: C.credentials, cache: C.cache }).then(function(k) {
          var V = k.body.getReader();
          return j._reader = V, j._aborted && j._reader.cancel(), {
            status: k.status,
            statusText: k.statusText,
            headers: k.headers,
            body: {
              getReader: function() {
                return V;
              }
            }
          };
        });
      }, g = function() {
        this.signal = {
          _reader: null,
          _aborted: !1
        }, this.abort = function() {
          this.signal._reader != null && this.signal._reader.cancel(), this.signal._aborted = !0;
        };
      };
    }
    function E() {
      this.bitsNeeded = 0, this.codePoint = 0;
    }
    E.prototype.decode = function(m) {
      function C(ne, ae, W) {
        if (W === 1)
          return ne >= 128 >> ae && ne << ae <= 2047;
        if (W === 2)
          return ne >= 2048 >> ae && ne << ae <= 55295 || ne >= 57344 >> ae && ne << ae <= 65535;
        if (W === 3)
          return ne >= 65536 >> ae && ne << ae <= 1114111;
        throw new Error();
      }
      function j(ne, ae) {
        if (ne === 6 * 1)
          return ae >> 6 > 15 ? 3 : ae > 31 ? 2 : 1;
        if (ne === 6 * 2)
          return ae > 15 ? 3 : 2;
        if (ne === 6 * 3)
          return 3;
        throw new Error();
      }
      for (var k = 65533, V = "", F = this.bitsNeeded, X = this.codePoint, fe = 0; fe < m.length; fe += 1) {
        var K = m[fe];
        F !== 0 && (K < 128 || K > 191 || !C(X << 6 | K & 63, F - 6, j(F, X))) && (F = 0, X = k, V += String.fromCharCode(X)), F === 0 ? (K >= 0 && K <= 127 ? (F = 0, X = K) : K >= 192 && K <= 223 ? (F = 6 * 1, X = K & 31) : K >= 224 && K <= 239 ? (F = 6 * 2, X = K & 15) : K >= 240 && K <= 247 ? (F = 6 * 3, X = K & 7) : (F = 0, X = k), F !== 0 && !C(X, F, j(F, X)) && (F = 0, X = k)) : (F -= 6, X = X << 6 | K & 63), F === 0 && (X <= 65535 ? V += String.fromCharCode(X) : (V += String.fromCharCode(55296 + (X - 65535 - 1 >> 10)), V += String.fromCharCode(56320 + (X - 65535 - 1 & 1023))));
      }
      return this.bitsNeeded = F, this.codePoint = X, V;
    };
    var w = function() {
      try {
        return new p().decode(new h().encode("test"), { stream: !0 }) === "test";
      } catch (m) {
        console.debug("TextDecoder does not support streaming option. Using polyfill instead: " + m);
      }
      return !1;
    };
    (p == null || h == null || !w()) && (p = E);
    var D = function() {
    };
    function B(m) {
      this.withCredentials = !1, this.readyState = 0, this.status = 0, this.statusText = "", this.responseText = "", this.onprogress = D, this.onload = D, this.onerror = D, this.onreadystatechange = D, this._contentType = "", this._xhr = m, this._sendTimeout = 0, this._abort = D;
    }
    B.prototype.open = function(m, C) {
      this._abort(!0);
      var j = this, k = this._xhr, V = 1, F = 0;
      this._abort = function(W) {
        j._sendTimeout !== 0 && (o(j._sendTimeout), j._sendTimeout = 0), (V === 1 || V === 2 || V === 3) && (V = 4, k.onload = D, k.onerror = D, k.onabort = D, k.onprogress = D, k.onreadystatechange = D, k.abort(), F !== 0 && (o(F), F = 0), W || (j.readyState = 4, j.onabort(null), j.onreadystatechange())), V = 0;
      };
      var X = function() {
        if (V === 1) {
          var W = 0, pe = "", qe = void 0;
          if ("contentType" in k)
            W = 200, pe = "OK", qe = k.contentType;
          else
            try {
              W = k.status, pe = k.statusText, qe = k.getResponseHeader("Content-Type");
            } catch {
              W = 0, pe = "", qe = void 0;
            }
          W !== 0 && (V = 2, j.readyState = 2, j.status = W, j.statusText = pe, j._contentType = qe, j.onreadystatechange());
        }
      }, fe = function() {
        if (X(), V === 2 || V === 3) {
          V = 3;
          var W = "";
          try {
            W = k.responseText;
          } catch {
          }
          j.readyState = 3, j.responseText = W, j.onprogress();
        }
      }, K = function(W, pe) {
        if ((pe == null || pe.preventDefault == null) && (pe = {
          preventDefault: D
        }), fe(), V === 1 || V === 2 || V === 3) {
          if (V = 4, F !== 0 && (o(F), F = 0), j.readyState = 4, W === "load")
            j.onload(pe);
          else if (W === "error")
            j.onerror(pe);
          else if (W === "abort")
            j.onabort(pe);
          else
            throw new TypeError();
          j.onreadystatechange();
        }
      }, ne = function(W) {
        k != null && (k.readyState === 4 ? (!("onload" in k) || !("onerror" in k) || !("onabort" in k)) && K(k.responseText === "" ? "error" : "load", W) : k.readyState === 3 ? "onprogress" in k || fe() : k.readyState === 2 && X());
      }, ae = function() {
        F = r(function() {
          ae();
        }, 500), k.readyState === 3 && fe();
      };
      "onload" in k && (k.onload = function(W) {
        K("load", W);
      }), "onerror" in k && (k.onerror = function(W) {
        K("error", W);
      }), "onabort" in k && (k.onabort = function(W) {
        K("abort", W);
      }), "onprogress" in k && (k.onprogress = fe), "onreadystatechange" in k && (k.onreadystatechange = function(W) {
        ne(W);
      }), ("contentType" in k || !("ontimeout" in i.prototype)) && (C += (C.indexOf("?") === -1 ? "?" : "&") + "padding=true"), k.open(m, C, !0), "readyState" in k && (F = r(function() {
        ae();
      }, 0));
    }, B.prototype.abort = function() {
      this._abort(!1);
    }, B.prototype.getResponseHeader = function(m) {
      return this._contentType;
    }, B.prototype.setRequestHeader = function(m, C) {
      var j = this._xhr;
      "setRequestHeader" in j && j.setRequestHeader(m, C);
    }, B.prototype.getAllResponseHeaders = function() {
      return this._xhr.getAllResponseHeaders != null && this._xhr.getAllResponseHeaders() || "";
    }, B.prototype.send = function() {
      if ((!("ontimeout" in i.prototype) || !("sendAsBinary" in i.prototype) && !("mozAnon" in i.prototype)) && c != null && c.readyState != null && c.readyState !== "complete") {
        var m = this;
        m._sendTimeout = r(function() {
          m._sendTimeout = 0, m.send();
        }, 4);
        return;
      }
      var C = this._xhr;
      "withCredentials" in C && (C.withCredentials = this.withCredentials);
      try {
        C.send(void 0);
      } catch (j) {
        throw j;
      }
    };
    function U(m) {
      return m.replace(/[A-Z]/g, function(C) {
        return String.fromCharCode(C.charCodeAt(0) + 32);
      });
    }
    function $(m) {
      for (var C = /* @__PURE__ */ Object.create(null), j = m.split(`\r
`), k = 0; k < j.length; k += 1) {
        var V = j[k], F = V.split(": "), X = F.shift(), fe = F.join(": ");
        C[U(X)] = fe;
      }
      this._map = C;
    }
    $.prototype.get = function(m) {
      return this._map[U(m)];
    }, i != null && i.HEADERS_RECEIVED == null && (i.HEADERS_RECEIVED = 2);
    function se() {
    }
    se.prototype.open = function(m, C, j, k, V, F, X) {
      m.open("GET", V);
      var fe = 0;
      m.onprogress = function() {
        var ne = m.responseText, ae = ne.slice(fe);
        fe += ae.length, j(ae);
      }, m.onerror = function(ne) {
        ne.preventDefault(), k(new Error("NetworkError"));
      }, m.onload = function() {
        k(null);
      }, m.onabort = function() {
        k(null);
      }, m.onreadystatechange = function() {
        if (m.readyState === i.HEADERS_RECEIVED) {
          var ne = m.status, ae = m.statusText, W = m.getResponseHeader("Content-Type"), pe = m.getAllResponseHeaders();
          C(ne, ae, W, new $(pe));
        }
      }, m.withCredentials = F;
      for (var K in X)
        Object.prototype.hasOwnProperty.call(X, K) && m.setRequestHeader(K, X[K]);
      return m.send(), m;
    };
    function H(m) {
      this._headers = m;
    }
    H.prototype.get = function(m) {
      return this._headers.get(m);
    };
    function de() {
    }
    de.prototype.open = function(m, C, j, k, V, F, X) {
      var fe = null, K = new g(), ne = K.signal, ae = new p();
      return f(V, {
        headers: X,
        credentials: F ? "include" : "same-origin",
        signal: ne,
        cache: "no-store"
      }).then(function(W) {
        return fe = W.body.getReader(), C(W.status, W.statusText, W.headers.get("Content-Type"), new H(W.headers)), new d(function(pe, qe) {
          var St = function() {
            fe.read().then(function(Te) {
              if (Te.done)
                pe(void 0);
              else {
                var Oe = ae.decode(Te.value, { stream: !0 });
                j(Oe), St();
              }
            }).catch(function(Te) {
              qe(Te);
            });
          };
          St();
        });
      }).catch(function(W) {
        if (W.name !== "AbortError")
          return W;
      }).then(function(W) {
        k(W);
      }), {
        abort: function() {
          fe != null && fe.cancel(), K.abort();
        }
      };
    };
    function Y() {
      this._listeners = /* @__PURE__ */ Object.create(null);
    }
    function G(m) {
      r(function() {
        throw m;
      }, 0);
    }
    Y.prototype.dispatchEvent = function(m) {
      m.target = this;
      var C = this._listeners[m.type];
      if (C != null)
        for (var j = C.length, k = 0; k < j; k += 1) {
          var V = C[k];
          try {
            typeof V.handleEvent == "function" ? V.handleEvent(m) : V.call(this, m);
          } catch (F) {
            G(F);
          }
        }
    }, Y.prototype.addEventListener = function(m, C) {
      m = String(m);
      var j = this._listeners, k = j[m];
      k == null && (k = [], j[m] = k);
      for (var V = !1, F = 0; F < k.length; F += 1)
        k[F] === C && (V = !0);
      V || k.push(C);
    }, Y.prototype.removeEventListener = function(m, C) {
      m = String(m);
      var j = this._listeners, k = j[m];
      if (k != null) {
        for (var V = [], F = 0; F < k.length; F += 1)
          k[F] !== C && V.push(k[F]);
        V.length === 0 ? delete j[m] : j[m] = V;
      }
    };
    function J(m) {
      this.type = m, this.target = void 0;
    }
    function te(m, C) {
      J.call(this, m), this.data = C.data, this.lastEventId = C.lastEventId;
    }
    te.prototype = Object.create(J.prototype);
    function N(m, C) {
      J.call(this, m), this.status = C.status, this.statusText = C.statusText, this.headers = C.headers;
    }
    N.prototype = Object.create(J.prototype);
    function b(m, C) {
      J.call(this, m), this.error = C.error;
    }
    b.prototype = Object.create(J.prototype);
    var I = -1, O = 0, A = 1, x = 2, P = -1, M = 0, ce = 1, he = 2, Ie = 3, Pe = /^text\/event\-stream(;.*)?$/i, Ve = 1e3, We = 18e6, Fe = function(m, C) {
      var j = m == null ? C : parseInt(m, 10);
      return j !== j && (j = C), He(j);
    }, He = function(m) {
      return Math.min(Math.max(m, Ve), We);
    }, le = function(m, C, j) {
      try {
        typeof C == "function" && C.call(m, j);
      } catch (k) {
        G(k);
      }
    };
    function Ee(m, C) {
      Y.call(this), C = C || {}, this.onopen = void 0, this.onmessage = void 0, this.onerror = void 0, this.url = void 0, this.readyState = void 0, this.withCredentials = void 0, this.headers = void 0, this._close = void 0, Wn(this, m, C);
    }
    function at() {
      return i != null && "withCredentials" in i.prototype || a == null ? new i() : new a();
    }
    var Et = f != null && R != null && "body" in R.prototype;
    function Wn(m, C, j) {
      C = String(C);
      var k = !!j.withCredentials, V = j.lastEventIdQueryParameterName || "lastEventId", F = He(1e3), X = Fe(j.heartbeatTimeout, 45e3), fe = "", K = F, ne = !1, ae = 0, W = j.headers || {}, pe = j.Transport, qe = Et && pe == null ? void 0 : new B(pe != null ? new pe() : at()), St = pe != null && typeof pe != "string" ? new pe() : qe == null ? new de() : new se(), Te = void 0, Oe = 0, Ue = I, vt = "", Mt = "", et = "", Wt = "", ke = M, Ct = 0, st = 0, Rt = function(Se, ve, Be, je) {
        if (Ue === O)
          if (Se === 200 && Be != null && Pe.test(Be)) {
            Ue = A, ne = Date.now(), K = F, m.readyState = A;
            var Ce = new N("open", {
              status: Se,
              statusText: ve,
              headers: je
            });
            m.dispatchEvent(Ce), le(m, m.onopen, Ce);
          } else {
            var Ae = "";
            Se !== 200 ? (ve && (ve = ve.replace(/\s+/g, " ")), Ae = "EventSource's response has a status " + Se + " " + ve + " that is not 200. Aborting the connection.") : Ae = "EventSource's response has a Content-Type specifying an unsupported type: " + (Be == null ? "-" : Be.replace(/\s+/g, " ")) + ". Aborting the connection.", Gt();
            var Ce = new N("error", {
              status: Se,
              statusText: ve,
              headers: je
            });
            m.dispatchEvent(Ce), le(m, m.onerror, Ce), console.error(Ae);
          }
      }, $t = function(Se) {
        if (Ue === A) {
          for (var ve = -1, Be = 0; Be < Se.length; Be += 1) {
            var je = Se.charCodeAt(Be);
            (je === `
`.charCodeAt(0) || je === "\r".charCodeAt(0)) && (ve = Be);
          }
          var Ce = (ve !== -1 ? Wt : "") + Se.slice(0, ve + 1);
          Wt = (ve === -1 ? Wt : "") + Se.slice(ve + 1), Se !== "" && (ne = Date.now(), ae += Se.length);
          for (var Ae = 0; Ae < Ce.length; Ae += 1) {
            var je = Ce.charCodeAt(Ae);
            if (ke === P && je === `
`.charCodeAt(0))
              ke = M;
            else if (ke === P && (ke = M), je === "\r".charCodeAt(0) || je === `
`.charCodeAt(0)) {
              if (ke !== M) {
                ke === ce && (st = Ae + 1);
                var Ze = Ce.slice(Ct, st - 1), tt = Ce.slice(st + (st < Ae && Ce.charCodeAt(st) === " ".charCodeAt(0) ? 1 : 0), Ae);
                Ze === "data" ? (vt += `
`, vt += tt) : Ze === "id" ? Mt = tt : Ze === "event" ? et = tt : Ze === "retry" ? (F = Fe(tt, F), K = F) : Ze === "heartbeatTimeout" && (X = Fe(tt, X), Oe !== 0 && (o(Oe), Oe = r(function() {
                  Dt();
                }, X)));
              }
              if (ke === M) {
                if (vt !== "") {
                  fe = Mt, et === "" && (et = "message");
                  var It = new te(et, {
                    data: vt.slice(1),
                    lastEventId: Mt
                  });
                  if (m.dispatchEvent(It), et === "open" ? le(m, m.onopen, It) : et === "message" ? le(m, m.onmessage, It) : et === "error" && le(m, m.onerror, It), Ue === x)
                    return;
                }
                vt = "", et = "";
              }
              ke = je === "\r".charCodeAt(0) ? P : M;
            } else
              ke === M && (Ct = Ae, ke = ce), ke === ce ? je === ":".charCodeAt(0) && (st = Ae + 1, ke = he) : ke === he && (ke = Ie);
          }
        }
      }, Ut = function(Se) {
        if (Ue === A || Ue === O) {
          Ue = I, Oe !== 0 && (o(Oe), Oe = 0), Oe = r(function() {
            Dt();
          }, K), K = He(Math.min(F * 16, K * 2)), m.readyState = O;
          var ve = new b("error", { error: Se });
          m.dispatchEvent(ve), le(m, m.onerror, ve), Se != null && console.error(Se);
        }
      }, Gt = function() {
        Ue = x, Te != null && (Te.abort(), Te = void 0), Oe !== 0 && (o(Oe), Oe = 0), m.readyState = x;
      }, Dt = function() {
        if (Oe = 0, Ue !== I) {
          if (!ne && Te != null)
            Ut(new Error("No activity within " + X + " milliseconds. " + (Ue === O ? "No response received." : ae + " chars received.") + " Reconnecting.")), Te != null && (Te.abort(), Te = void 0);
          else {
            var Se = Math.max((ne || Date.now()) + X - Date.now(), 1);
            ne = !1, Oe = r(function() {
              Dt();
            }, Se);
          }
          return;
        }
        ne = !1, ae = 0, Oe = r(function() {
          Dt();
        }, X), Ue = O, vt = "", et = "", Mt = fe, Wt = "", Ct = 0, st = 0, ke = M;
        var ve = C;
        if (C.slice(0, 5) !== "data:" && C.slice(0, 5) !== "blob:" && fe !== "") {
          var Be = C.indexOf("?");
          ve = Be === -1 ? C : C.slice(0, Be + 1) + C.slice(Be + 1).replace(/(?:^|&)([^=&]*)(?:=[^&]*)?/g, function(tt, It) {
            return It === V ? "" : tt;
          }), ve += (C.indexOf("?") === -1 ? "?" : "&") + V + "=" + encodeURIComponent(fe);
        }
        var je = m.withCredentials, Ce = {};
        Ce.Accept = "text/event-stream";
        var Ae = m.headers;
        if (Ae != null)
          for (var Ze in Ae)
            Object.prototype.hasOwnProperty.call(Ae, Ze) && (Ce[Ze] = Ae[Ze]);
        try {
          Te = St.open(qe, Rt, $t, Ut, ve, je, Ce);
        } catch (tt) {
          throw Gt(), tt;
        }
      };
      m.url = C, m.readyState = O, m.withCredentials = k, m.headers = W, m._close = Gt, Dt();
    }
    Ee.prototype = Object.create(Y.prototype), Ee.prototype.CONNECTING = O, Ee.prototype.OPEN = A, Ee.prototype.CLOSED = x, Ee.prototype.close = function() {
      this._close();
    }, Ee.CONNECTING = O, Ee.OPEN = A, Ee.CLOSED = x, Ee.prototype.withCredentials = void 0;
    var kt = l;
    i != null && (l == null || !("withCredentials" in l.prototype)) && (kt = Ee), function(m) {
      {
        var C = m(t);
        C !== void 0 && (e.exports = C);
      }
    }(function(m) {
      m.EventSourcePolyfill = Ee, m.NativeEventSource = l, m.EventSource = kt;
    });
  })(typeof globalThis > "u" ? typeof window < "u" ? window : typeof self < "u" ? self : xt : globalThis);
})(cr, cr.exports);
var hs = cr.exports;
const Wr = {
  doAskPreCheck: (e, t, n) => {
    Sr.isTokenNeedRefresh(60) ? Ke.handleWebAccessTokenExpire().then((r) => {
      Wr.doSseChatAsk(e, t, n);
    }) : Wr.doSseChatAsk(e, t, n);
  },
  doSseChatAsk: (e, t, n) => {
    let r;
    const o = localStorage.getItem("x-access-token");
    var i = Object.keys(e).map((a) => a + "=" + e[a]).join("&");
    r = new hs.EventSourcePolyfill(n + "?" + i, {
      headers: {
        "x-access-token": o ?? "",
        "x-request-id": un()
      }
    }), r.onopen = () => {
    }, r.onerror = (a) => {
      console.log("onerror", a), r.close();
    }, r.onmessage = (a) => {
      t(a.data, r);
    };
  }
}, _u = [
  {
    en: "China",
    cn: "中国",
    code: "+86"
  },
  {
    en: "Hongkong",
    cn: "香港",
    code: "+852"
  },
  {
    en: "United Kiongdom",
    cn: "英国",
    code: "+44"
  },
  {
    en: "United States of America",
    cn: "美国",
    code: "+1"
  }
], gs = "_loginContainer_pzr3g_1", ms = "_loginForm_pzr3g_9", Es = "_loginTabs_pzr3g_15", Ss = "_active_pzr3g_37", vs = "_tablinks_pzr3g_41", Rs = "_tabcontent_pzr3g_46", Is = "_loginElement_pzr3g_55", ys = "_userName_pzr3g_62", As = "_countryCodeSelect_pzr3g_68", ws = "_password_pzr3g_72", bs = "_turnstile_pzr3g_113", Ts = "_loginButton_pzr3g_117", Os = "_operate_pzr3g_130", ks = "_handleSituation_pzr3g_138", we = {
  loginContainer: gs,
  loginForm: ms,
  loginTabs: Es,
  active: Ss,
  tablinks: vs,
  tabcontent: Rs,
  loginElement: Is,
  userName: ys,
  countryCodeSelect: As,
  password: ws,
  turnstile: bs,
  loginButton: Ts,
  operate: Os,
  handleSituation: ks
};
var ur = function() {
  return ur = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ur.apply(this, arguments);
};
function rt(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function s(d) {
      try {
        c(r.next(d));
      } catch (f) {
        a(f);
      }
    }
    function l(d) {
      try {
        c(r.throw(d));
      } catch (f) {
        a(f);
      }
    }
    function c(d) {
      d.done ? i(d.value) : o(d.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function ot(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(d) {
      return l([c, d]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, o && (i = c[0] & 2 ? o.return : c[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, c[1])).done)
          return i;
        switch (o = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, o = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = c;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(c);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (d) {
        c = [6, d], o = 0;
      } finally {
        r = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function To(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Oo = "4.0.0";
function Qt(e, t) {
  return new Promise(function(n) {
    return setTimeout(n, e, t);
  });
}
function Nn() {
  return Qt(0);
}
function Cs(e, t) {
  t === void 0 && (t = 1 / 0);
  var n = window.requestIdleCallback;
  return n ? new Promise(function(r) {
    return n.call(window, function() {
      return r();
    }, { timeout: t });
  }) : Qt(Math.min(e, t));
}
function ko(e) {
  return !!e && typeof e.then == "function";
}
function Ur(e, t) {
  try {
    var n = e();
    ko(n) ? n.then(function(r) {
      return t(!0, r);
    }, function(r) {
      return t(!1, r);
    }) : t(!0, n);
  } catch (r) {
    t(!1, r);
  }
}
function Gr(e, t, n) {
  return n === void 0 && (n = 16), rt(this, void 0, void 0, function() {
    var r, o, i, a;
    return ot(this, function(s) {
      switch (s.label) {
        case 0:
          r = Array(e.length), o = Date.now(), i = 0, s.label = 1;
        case 1:
          return i < e.length ? (r[i] = t(e[i], i), a = Date.now(), a >= o + n ? (o = a, [4, Qt(0)]) : [3, 3]) : [3, 4];
        case 2:
          s.sent(), s.label = 3;
        case 3:
          return ++i, [3, 1];
        case 4:
          return [2, r];
      }
    });
  });
}
function ln(e) {
  e.then(void 0, function() {
  });
}
function At(e, t) {
  e = [e[0] >>> 16, e[0] & 65535, e[1] >>> 16, e[1] & 65535], t = [t[0] >>> 16, t[0] & 65535, t[1] >>> 16, t[1] & 65535];
  var n = [0, 0, 0, 0];
  return n[3] += e[3] + t[3], n[2] += n[3] >>> 16, n[3] &= 65535, n[2] += e[2] + t[2], n[1] += n[2] >>> 16, n[2] &= 65535, n[1] += e[1] + t[1], n[0] += n[1] >>> 16, n[1] &= 65535, n[0] += e[0] + t[0], n[0] &= 65535, [n[0] << 16 | n[1], n[2] << 16 | n[3]];
}
function Xe(e, t) {
  e = [e[0] >>> 16, e[0] & 65535, e[1] >>> 16, e[1] & 65535], t = [t[0] >>> 16, t[0] & 65535, t[1] >>> 16, t[1] & 65535];
  var n = [0, 0, 0, 0];
  return n[3] += e[3] * t[3], n[2] += n[3] >>> 16, n[3] &= 65535, n[2] += e[2] * t[3], n[1] += n[2] >>> 16, n[2] &= 65535, n[2] += e[3] * t[2], n[1] += n[2] >>> 16, n[2] &= 65535, n[1] += e[1] * t[3], n[0] += n[1] >>> 16, n[1] &= 65535, n[1] += e[2] * t[2], n[0] += n[1] >>> 16, n[1] &= 65535, n[1] += e[3] * t[1], n[0] += n[1] >>> 16, n[1] &= 65535, n[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0], n[0] &= 65535, [n[0] << 16 | n[1], n[2] << 16 | n[3]];
}
function qt(e, t) {
  return t %= 64, t === 32 ? [e[1], e[0]] : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t | e[0] >>> 32 - t] : (t -= 32, [e[1] << t | e[0] >>> 32 - t, e[0] << t | e[1] >>> 32 - t]);
}
function Ge(e, t) {
  return t %= 64, t === 0 ? e : t < 32 ? [e[0] << t | e[1] >>> 32 - t, e[1] << t] : [e[1] << t - 32, 0];
}
function ge(e, t) {
  return [e[0] ^ t[0], e[1] ^ t[1]];
}
function zr(e) {
  return e = ge(e, [0, e[0] >>> 1]), e = Xe(e, [4283543511, 3981806797]), e = ge(e, [0, e[0] >>> 1]), e = Xe(e, [3301882366, 444984403]), e = ge(e, [0, e[0] >>> 1]), e;
}
function Ds(e, t) {
  e = e || "", t = t || 0;
  var n = e.length % 16, r = e.length - n, o = [0, t], i = [0, t], a = [0, 0], s = [0, 0], l = [2277735313, 289559509], c = [1291169091, 658871167], d;
  for (d = 0; d < r; d = d + 16)
    a = [
      e.charCodeAt(d + 4) & 255 | (e.charCodeAt(d + 5) & 255) << 8 | (e.charCodeAt(d + 6) & 255) << 16 | (e.charCodeAt(d + 7) & 255) << 24,
      e.charCodeAt(d) & 255 | (e.charCodeAt(d + 1) & 255) << 8 | (e.charCodeAt(d + 2) & 255) << 16 | (e.charCodeAt(d + 3) & 255) << 24
    ], s = [
      e.charCodeAt(d + 12) & 255 | (e.charCodeAt(d + 13) & 255) << 8 | (e.charCodeAt(d + 14) & 255) << 16 | (e.charCodeAt(d + 15) & 255) << 24,
      e.charCodeAt(d + 8) & 255 | (e.charCodeAt(d + 9) & 255) << 8 | (e.charCodeAt(d + 10) & 255) << 16 | (e.charCodeAt(d + 11) & 255) << 24
    ], a = Xe(a, l), a = qt(a, 31), a = Xe(a, c), o = ge(o, a), o = qt(o, 27), o = At(o, i), o = At(Xe(o, [0, 5]), [0, 1390208809]), s = Xe(s, c), s = qt(s, 33), s = Xe(s, l), i = ge(i, s), i = qt(i, 31), i = At(i, o), i = At(Xe(i, [0, 5]), [0, 944331445]);
  switch (a = [0, 0], s = [0, 0], n) {
    case 15:
      s = ge(s, Ge([0, e.charCodeAt(d + 14)], 48));
    case 14:
      s = ge(s, Ge([0, e.charCodeAt(d + 13)], 40));
    case 13:
      s = ge(s, Ge([0, e.charCodeAt(d + 12)], 32));
    case 12:
      s = ge(s, Ge([0, e.charCodeAt(d + 11)], 24));
    case 11:
      s = ge(s, Ge([0, e.charCodeAt(d + 10)], 16));
    case 10:
      s = ge(s, Ge([0, e.charCodeAt(d + 9)], 8));
    case 9:
      s = ge(s, [0, e.charCodeAt(d + 8)]), s = Xe(s, c), s = qt(s, 33), s = Xe(s, l), i = ge(i, s);
    case 8:
      a = ge(a, Ge([0, e.charCodeAt(d + 7)], 56));
    case 7:
      a = ge(a, Ge([0, e.charCodeAt(d + 6)], 48));
    case 6:
      a = ge(a, Ge([0, e.charCodeAt(d + 5)], 40));
    case 5:
      a = ge(a, Ge([0, e.charCodeAt(d + 4)], 32));
    case 4:
      a = ge(a, Ge([0, e.charCodeAt(d + 3)], 24));
    case 3:
      a = ge(a, Ge([0, e.charCodeAt(d + 2)], 16));
    case 2:
      a = ge(a, Ge([0, e.charCodeAt(d + 1)], 8));
    case 1:
      a = ge(a, [0, e.charCodeAt(d)]), a = Xe(a, l), a = qt(a, 31), a = Xe(a, c), o = ge(o, a);
  }
  return o = ge(o, [0, e.length]), i = ge(i, [0, e.length]), o = At(o, i), i = At(i, o), o = zr(o), i = zr(i), o = At(o, i), i = At(i, o), ("00000000" + (o[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (o[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (i[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (i[1] >>> 0).toString(16)).slice(-8);
}
function Ns(e) {
  var t;
  return ur({ name: e.name, message: e.message, stack: (t = e.stack) === null || t === void 0 ? void 0 : t.split(`
`) }, e);
}
function Ls(e, t) {
  for (var n = 0, r = e.length; n < r; ++n)
    if (e[n] === t)
      return !0;
  return !1;
}
function Ps(e, t) {
  return !Ls(e, t);
}
function vr(e) {
  return parseInt(e);
}
function nt(e) {
  return parseFloat(e);
}
function pt(e, t) {
  return typeof e == "number" && isNaN(e) ? t : e;
}
function it(e) {
  return e.reduce(function(t, n) {
    return t + (n ? 1 : 0);
  }, 0);
}
function Co(e, t) {
  if (t === void 0 && (t = 1), Math.abs(t) >= 1)
    return Math.round(e / t) * t;
  var n = 1 / t;
  return Math.round(e * n) / n;
}
function Bs(e) {
  for (var t, n, r = "Unexpected syntax '".concat(e, "'"), o = /^\s*([a-z-]*)(.*)$/i.exec(e), i = o[1] || void 0, a = {}, s = /([.:#][\w-]+|\[.+?\])/gi, l = function(R, p) {
    a[R] = a[R] || [], a[R].push(p);
  }; ; ) {
    var c = s.exec(o[2]);
    if (!c)
      break;
    var d = c[0];
    switch (d[0]) {
      case ".":
        l("class", d.slice(1));
        break;
      case "#":
        l("id", d.slice(1));
        break;
      case "[": {
        var f = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(d);
        if (f)
          l(f[1], (n = (t = f[4]) !== null && t !== void 0 ? t : f[5]) !== null && n !== void 0 ? n : "");
        else
          throw new Error(r);
        break;
      }
      default:
        throw new Error(r);
    }
  }
  return [i, a];
}
function js(e) {
  return typeof e != "function";
}
function Hs(e, t) {
  var n = new Promise(function(r) {
    var o = Date.now();
    Ur(e.bind(null, t), function() {
      for (var i = [], a = 0; a < arguments.length; a++)
        i[a] = arguments[a];
      var s = Date.now() - o;
      if (!i[0])
        return r(function() {
          return { error: i[1], duration: s };
        });
      var l = i[1];
      if (js(l))
        return r(function() {
          return { value: l, duration: s };
        });
      r(function() {
        return new Promise(function(c) {
          var d = Date.now();
          Ur(l, function() {
            for (var f = [], R = 0; R < arguments.length; R++)
              f[R] = arguments[R];
            var p = s + Date.now() - d;
            if (!f[0])
              return c({ error: f[1], duration: p });
            c({ value: f[1], duration: p });
          });
        });
      });
    });
  });
  return ln(n), function() {
    return n.then(function(o) {
      return o();
    });
  };
}
function Js(e, t, n) {
  var r = Object.keys(e).filter(function(i) {
    return Ps(n, i);
  }), o = Gr(r, function(i) {
    return Hs(e[i], t);
  });
  return ln(o), function() {
    return rt(this, void 0, void 0, function() {
      var a, s, l, c, d;
      return ot(this, function(f) {
        switch (f.label) {
          case 0:
            return [4, o];
          case 1:
            return a = f.sent(), [4, Gr(a, function(R) {
              var p = R();
              return ln(p), p;
            })];
          case 2:
            return s = f.sent(), [
              4,
              Promise.all(s)
              // Keeping the component keys order the same as the source keys order
            ];
          case 3:
            for (l = f.sent(), c = {}, d = 0; d < r.length; ++d)
              c[r[d]] = l[d];
            return [2, c];
        }
      });
    });
  };
}
function Do() {
  var e = window, t = navigator;
  return it([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in t,
    "msPointerEnabled" in t
  ]) >= 4;
}
function xs() {
  var e = window, t = navigator;
  return it(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in t, "msSaveBlob" in t]) >= 3 && !Do();
}
function Rr() {
  var e = window, t = navigator;
  return it([
    "webkitPersistentStorage" in t,
    "webkitTemporaryStorage" in t,
    t.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function pn() {
  var e = window, t = navigator;
  return it([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    t.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in t,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function Ir() {
  var e = window;
  return it([
    "safari" in e,
    !("ongestureend" in e),
    !("TouchEvent" in e),
    !("orientation" in e),
    "HTMLElement" in e && !("autocapitalize" in HTMLElement.prototype),
    "Document" in e && "pointerLockElement" in Document.prototype
  ]) >= 4;
}
function No() {
  var e, t, n = window;
  return it([
    "buildID" in navigator,
    "MozAppearance" in ((t = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && t !== void 0 ? t : {}),
    "onmozfullscreenchange" in n,
    "mozInnerScreenX" in n,
    "CSSMozDocumentRule" in n,
    "CanvasCaptureMediaStream" in n
  ]) >= 4;
}
function Fs() {
  var e = window;
  return it([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function Ms() {
  var e = window;
  return it([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function Ws() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, t = e.width / e.height;
  return it([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    // iPhone 4S that runs iOS 9 matches this. But it won't match the criteria above, so it won't be detected as iPad.
    t > 0.65 && t < 1.53
  ]) >= 2;
}
function Us() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function Gs() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function Lo() {
  var e = Rr(), t = No();
  if (!e && !t)
    return !1;
  var n = window;
  return it([
    "onorientationchange" in n,
    "orientation" in n,
    e && !("SharedWorker" in n),
    t && /android/i.test(navigator.appVersion)
  ]) >= 2;
}
function zs() {
  var e = window, t = e.OfflineAudioContext || e.webkitOfflineAudioContext;
  if (!t)
    return -2;
  if (Vs())
    return -1;
  var n = 4500, r = 5e3, o = new t(1, r, 44100), i = o.createOscillator();
  i.type = "triangle", i.frequency.value = 1e4;
  var a = o.createDynamicsCompressor();
  a.threshold.value = -50, a.knee.value = 40, a.ratio.value = 12, a.attack.value = 0, a.release.value = 0.25, i.connect(a), a.connect(o.destination), i.start(0);
  var s = qs(o), l = s[0], c = s[1], d = l.then(function(f) {
    return Zs(f.getChannelData(0).subarray(n));
  }, function(f) {
    if (f.name === "timeout" || f.name === "suspended")
      return -3;
    throw f;
  });
  return ln(d), function() {
    return c(), d;
  };
}
function Vs() {
  return pn() && !Ir() && !Ms();
}
function qs(e) {
  var t = 3, n = 500, r = 500, o = 5e3, i = function() {
  }, a = new Promise(function(s, l) {
    var c = !1, d = 0, f = 0;
    e.oncomplete = function(h) {
      return s(h.renderedBuffer);
    };
    var R = function() {
      setTimeout(function() {
        return l(Vr(
          "timeout"
          /* InnerErrorName.Timeout */
        ));
      }, Math.min(r, f + o - Date.now()));
    }, p = function() {
      try {
        var h = e.startRendering();
        switch (ko(h) && ln(h), e.state) {
          case "running":
            f = Date.now(), c && R();
            break;
          case "suspended":
            document.hidden || d++, c && d >= t ? l(Vr(
              "suspended"
              /* InnerErrorName.Suspended */
            )) : setTimeout(p, n);
            break;
        }
      } catch (g) {
        l(g);
      }
    };
    p(), i = function() {
      c || (c = !0, f > 0 && R());
    };
  });
  return [a, i];
}
function Zs(e) {
  for (var t = 0, n = 0; n < e.length; ++n)
    t += Math.abs(e[n]);
  return t;
}
function Vr(e) {
  var t = new Error(e);
  return t.name = e, t;
}
function Po(e, t, n) {
  var r, o, i;
  return n === void 0 && (n = 50), rt(this, void 0, void 0, function() {
    var a, s;
    return ot(this, function(l) {
      switch (l.label) {
        case 0:
          a = document, l.label = 1;
        case 1:
          return a.body ? [3, 3] : [4, Qt(n)];
        case 2:
          return l.sent(), [3, 1];
        case 3:
          s = a.createElement("iframe"), l.label = 4;
        case 4:
          return l.trys.push([4, , 10, 11]), [4, new Promise(function(c, d) {
            var f = !1, R = function() {
              f = !0, c();
            }, p = function(v) {
              f = !0, d(v);
            };
            s.onload = R, s.onerror = p;
            var h = s.style;
            h.setProperty("display", "block", "important"), h.position = "absolute", h.top = "0", h.left = "0", h.visibility = "hidden", t && "srcdoc" in s ? s.srcdoc = t : s.src = "about:blank", a.body.appendChild(s);
            var g = function() {
              var v, E;
              f || (((E = (v = s.contentWindow) === null || v === void 0 ? void 0 : v.document) === null || E === void 0 ? void 0 : E.readyState) === "complete" ? R() : setTimeout(g, 10));
            };
            g();
          })];
        case 5:
          l.sent(), l.label = 6;
        case 6:
          return !((o = (r = s.contentWindow) === null || r === void 0 ? void 0 : r.document) === null || o === void 0) && o.body ? [3, 8] : [4, Qt(n)];
        case 7:
          return l.sent(), [3, 6];
        case 8:
          return [4, e(s, s.contentWindow)];
        case 9:
          return [2, l.sent()];
        case 10:
          return (i = s.parentNode) === null || i === void 0 || i.removeChild(s), [
            7
            /*endfinally*/
          ];
        case 11:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Ys(e) {
  for (var t = Bs(e), n = t[0], r = t[1], o = document.createElement(n ?? "div"), i = 0, a = Object.keys(r); i < a.length; i++) {
    var s = a[i], l = r[s].join(" ");
    s === "style" ? Xs(o.style, l) : o.setAttribute(s, l);
  }
  return o;
}
function Xs(e, t) {
  for (var n = 0, r = t.split(";"); n < r.length; n++) {
    var o = r[n], i = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(o);
    if (i) {
      var a = i[1], s = i[2], l = i[4];
      e.setProperty(a, s, l || "");
    }
  }
}
var Ks = "mmMwWLliI0O&1", Qs = "48px", Zt = ["monospace", "sans-serif", "serif"], qr = [
  // This is android-specific font from "Roboto" family
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function _s() {
  var e = this;
  return Po(function(t, n) {
    var r = n.document;
    return rt(e, void 0, void 0, function() {
      var o, i, a, s, l, c, d, f, R, p, h, g;
      return ot(this, function(v) {
        switch (v.label) {
          case 0:
            return o = r.body, o.style.fontSize = Qs, i = r.createElement("div"), i.style.setProperty("visibility", "hidden", "important"), a = {}, s = {}, l = function(E) {
              var w = r.createElement("span"), D = w.style;
              return D.position = "absolute", D.top = "0", D.left = "0", D.fontFamily = E, w.textContent = Ks, i.appendChild(w), w;
            }, c = function(E, w) {
              return l("'".concat(E, "',").concat(w));
            }, d = function() {
              return Zt.map(l);
            }, f = function() {
              for (var E = {}, w = function($) {
                E[$] = Zt.map(function(se) {
                  return c($, se);
                });
              }, D = 0, B = qr; D < B.length; D++) {
                var U = B[D];
                w(U);
              }
              return E;
            }, R = function(E) {
              return Zt.some(function(w, D) {
                return E[D].offsetWidth !== a[w] || E[D].offsetHeight !== s[w];
              });
            }, p = d(), h = f(), o.appendChild(i), [
              4,
              Nn()
              // get the default width for the three base fonts
            ];
          case 1:
            for (v.sent(), g = 0; g < Zt.length; g++)
              a[Zt[g]] = p[g].offsetWidth, s[Zt[g]] = p[g].offsetHeight;
            return [2, qr.filter(function(E) {
              return R(h[E]);
            })];
        }
      });
    });
  });
}
function $s() {
  var e = navigator.plugins;
  if (e) {
    for (var t = [], n = 0; n < e.length; ++n) {
      var r = e[n];
      if (r) {
        for (var o = [], i = 0; i < r.length; ++i) {
          var a = r[i];
          o.push({
            type: a.type,
            suffixes: a.suffixes
          });
        }
        t.push({
          name: r.name,
          description: r.description,
          mimeTypes: o
        });
      }
    }
    return t;
  }
}
function ec() {
  return rt(this, void 0, void 0, function() {
    var e, t, n, r, o, i, a, s;
    return ot(this, function(l) {
      switch (l.label) {
        case 0:
          return e = !1, r = tc(), o = r[0], i = r[1], nc(o, i) ? [3, 1] : (t = n = "unsupported", [3, 5]);
        case 1:
          return e = rc(i), oc(o, i), [4, Nn()];
        case 2:
          return l.sent(), a = _n(o), s = _n(o), a === s ? [3, 3] : (t = n = "unstable", [3, 5]);
        case 3:
          return n = a, ic(o, i), [4, Nn()];
        case 4:
          l.sent(), t = _n(o), l.label = 5;
        case 5:
          return [2, { winding: e, geometry: t, text: n }];
      }
    });
  });
}
function tc() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function nc(e, t) {
  return !!(t && e.toDataURL);
}
function rc(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function oc(e, t) {
  e.width = 240, e.height = 60, t.textBaseline = "alphabetic", t.fillStyle = "#f60", t.fillRect(100, 1, 62, 20), t.fillStyle = "#069", t.font = '11pt "Times New Roman"';
  var n = "Cwm fjordbank gly ".concat(
    String.fromCharCode(55357, 56835)
    /* 😃 */
  );
  t.fillText(n, 2, 15), t.fillStyle = "rgba(102, 204, 0, 0.2)", t.font = "18pt Arial", t.fillText(n, 4, 45);
}
function ic(e, t) {
  e.width = 122, e.height = 110, t.globalCompositeOperation = "multiply";
  for (var n = 0, r = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; n < r.length; n++) {
    var o = r[n], i = o[0], a = o[1], s = o[2];
    t.fillStyle = i, t.beginPath(), t.arc(a, s, 40, 0, Math.PI * 2, !0), t.closePath(), t.fill();
  }
  t.fillStyle = "#f9c", t.arc(60, 60, 60, 0, Math.PI * 2, !0), t.arc(60, 60, 20, 0, Math.PI * 2, !0), t.fill("evenodd");
}
function _n(e) {
  return e.toDataURL();
}
function ac() {
  var e = navigator, t = 0, n;
  e.maxTouchPoints !== void 0 ? t = vr(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (t = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), n = !0;
  } catch {
    n = !1;
  }
  var r = "ontouchstart" in window;
  return {
    maxTouchPoints: t,
    touchEvent: n,
    touchStart: r
  };
}
function sc() {
  return navigator.oscpu;
}
function cc() {
  var e = navigator, t = [], n = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (n !== void 0 && t.push([n]), Array.isArray(e.languages))
    Rr() && Fs() || t.push(e.languages);
  else if (typeof e.languages == "string") {
    var r = e.languages;
    r && t.push(r.split(","));
  }
  return t;
}
function uc() {
  return window.screen.colorDepth;
}
function lc() {
  return pt(nt(navigator.deviceMemory), void 0);
}
function dc() {
  var e = screen, t = function(r) {
    return pt(vr(r), null);
  }, n = [t(e.width), t(e.height)];
  return n.sort().reverse(), n;
}
var fc = 2500, pc = 10, On, $n;
function hc() {
  if ($n === void 0) {
    var e = function() {
      var t = lr();
      dr(t) ? $n = setTimeout(e, fc) : (On = t, $n = void 0);
    };
    e();
  }
}
function gc() {
  var e = this;
  return hc(), function() {
    return rt(e, void 0, void 0, function() {
      var t;
      return ot(this, function(n) {
        switch (n.label) {
          case 0:
            return t = lr(), dr(t) ? On ? [2, To([], On, !0)] : Us() ? [4, Gs()] : [3, 2] : [3, 2];
          case 1:
            n.sent(), t = lr(), n.label = 2;
          case 2:
            return dr(t) || (On = t), [2, t];
        }
      });
    });
  };
}
function mc() {
  var e = this, t = gc();
  return function() {
    return rt(e, void 0, void 0, function() {
      var n, r;
      return ot(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, t()];
          case 1:
            return n = o.sent(), r = function(i) {
              return i === null ? null : Co(i, pc);
            }, [2, [r(n[0]), r(n[1]), r(n[2]), r(n[3])]];
        }
      });
    });
  };
}
function lr() {
  var e = screen;
  return [
    pt(nt(e.availTop), null),
    pt(nt(e.width) - nt(e.availWidth) - pt(nt(e.availLeft), 0), null),
    pt(nt(e.height) - nt(e.availHeight) - pt(nt(e.availTop), 0), null),
    pt(nt(e.availLeft), null)
  ];
}
function dr(e) {
  for (var t = 0; t < 4; ++t)
    if (e[t])
      return !1;
  return !0;
}
function Ec() {
  return pt(vr(navigator.hardwareConcurrency), void 0);
}
function Sc() {
  var e, t = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (t) {
    var n = new t().resolvedOptions().timeZone;
    if (n)
      return n;
  }
  var r = -vc();
  return "UTC".concat(r >= 0 ? "+" : "").concat(Math.abs(r));
}
function vc() {
  var e = (/* @__PURE__ */ new Date()).getFullYear();
  return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    nt(new Date(e, 0, 1).getTimezoneOffset()),
    nt(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function Rc() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function Ic() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function yc() {
  if (!(Do() || xs()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function Ac() {
  return !!window.openDatabase;
}
function wc() {
  return navigator.cpuClass;
}
function bc() {
  var e = navigator.platform;
  return e === "MacIntel" && pn() && !Ir() ? Ws() ? "iPad" : "iPhone" : e;
}
function Tc() {
  return navigator.vendor || "";
}
function Oc() {
  for (var e = [], t = 0, n = [
    // Blink and some browsers on iOS
    "chrome",
    // Safari on macOS
    "safari",
    // Chrome on iOS (checked in 85 on 13 and 87 on 14)
    "__crWeb",
    "__gCrWeb",
    // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
    "yandex",
    // Yandex Browser on iOS (checked in 21.2 on 14)
    "__yb",
    "__ybro",
    // Firefox on iOS (checked in 32 on 14)
    "__firefox__",
    // Edge on iOS (checked in 46 on 14)
    "__edgeTrackingPreventionStatistics",
    "webkit",
    // Opera Touch on iOS (checked in 2.6 on 14)
    "oprt",
    // Samsung Internet on Android (checked in 11.1)
    "samsungAr",
    // UC Browser on Android (checked in 12.10 and 13.0)
    "ucweb",
    "UCShellJava",
    // Puffin on Android (checked in 9.0)
    "puffinDevice"
    // UC on iOS and Opera on Android have no specific global variables
    // Edge for Android isn't checked
  ]; t < n.length; t++) {
    var r = n[t], o = window[r];
    o && typeof o == "object" && e.push(r);
  }
  return e.sort();
}
function kc() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var t = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", t;
  } catch {
    return !1;
  }
}
function Cc() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function Dc(e) {
  var t = e === void 0 ? {} : e, n = t.debug;
  return rt(this, void 0, void 0, function() {
    var r, o, i, a, s, l;
    return ot(this, function(c) {
      switch (c.label) {
        case 0:
          return Nc() ? (r = Cc(), o = Object.keys(r), i = (l = []).concat.apply(l, o.map(function(d) {
            return r[d];
          })), [4, Lc(i)]) : [2, void 0];
        case 1:
          return a = c.sent(), n && Pc(r, a), s = o.filter(function(d) {
            var f = r[d], R = it(f.map(function(p) {
              return a[p];
            }));
            return R > f.length * 0.6;
          }), s.sort(), [2, s];
      }
    });
  });
}
function Nc() {
  return pn() || Lo();
}
function Lc(e) {
  var t;
  return rt(this, void 0, void 0, function() {
    var n, r, o, i, l, a, s, l;
    return ot(this, function(c) {
      switch (c.label) {
        case 0:
          for (n = document, r = n.createElement("div"), o = new Array(e.length), i = {}, Zr(r), l = 0; l < e.length; ++l)
            a = Ys(e[l]), a.tagName === "DIALOG" && a.show(), s = n.createElement("div"), Zr(s), s.appendChild(a), r.appendChild(s), o[l] = a;
          c.label = 1;
        case 1:
          return n.body ? [3, 3] : [4, Qt(50)];
        case 2:
          return c.sent(), [3, 1];
        case 3:
          return n.body.appendChild(r), [4, Nn()];
        case 4:
          c.sent();
          try {
            for (l = 0; l < e.length; ++l)
              o[l].offsetParent || (i[e[l]] = !0);
          } finally {
            (t = r.parentNode) === null || t === void 0 || t.removeChild(r);
          }
          return [2, i];
      }
    });
  });
}
function Zr(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
function Pc(e, t) {
  for (var n = "DOM blockers debug:\n```", r = 0, o = Object.keys(e); r < o.length; r++) {
    var i = o[r];
    n += `
`.concat(i, ":");
    for (var a = 0, s = e[i]; a < s.length; a++) {
      var l = s[a];
      n += `
  `.concat(t[l] ? "🚫" : "➡️", " ").concat(l);
    }
  }
  console.log("".concat(n, "\n```"));
}
function Bc() {
  for (var e = 0, t = ["rec2020", "p3", "srgb"]; e < t.length; e++) {
    var n = t[e];
    if (matchMedia("(color-gamut: ".concat(n, ")")).matches)
      return n;
  }
}
function jc() {
  if (Yr("inverted"))
    return !0;
  if (Yr("none"))
    return !1;
}
function Yr(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function Hc() {
  if (Xr("active"))
    return !0;
  if (Xr("none"))
    return !1;
}
function Xr(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var Jc = 100;
function xc() {
  if (matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= Jc; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function Fc() {
  if (Yt("no-preference"))
    return 0;
  if (Yt("high") || Yt("more"))
    return 1;
  if (Yt("low") || Yt("less"))
    return -1;
  if (Yt("forced"))
    return 10;
}
function Yt(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function Mc() {
  if (Kr("reduce"))
    return !0;
  if (Kr("no-preference"))
    return !1;
}
function Kr(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function Wc() {
  if (Qr("high"))
    return !0;
  if (Qr("standard"))
    return !1;
}
function Qr(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var ie = Math, xe = function() {
  return 0;
};
function Uc() {
  var e = ie.acos || xe, t = ie.acosh || xe, n = ie.asin || xe, r = ie.asinh || xe, o = ie.atanh || xe, i = ie.atan || xe, a = ie.sin || xe, s = ie.sinh || xe, l = ie.cos || xe, c = ie.cosh || xe, d = ie.tan || xe, f = ie.tanh || xe, R = ie.exp || xe, p = ie.expm1 || xe, h = ie.log1p || xe, g = function(H) {
    return ie.pow(ie.PI, H);
  }, v = function(H) {
    return ie.log(H + ie.sqrt(H * H - 1));
  }, E = function(H) {
    return ie.log(H + ie.sqrt(H * H + 1));
  }, w = function(H) {
    return ie.log((1 + H) / (1 - H)) / 2;
  }, D = function(H) {
    return ie.exp(H) - 1 / ie.exp(H) / 2;
  }, B = function(H) {
    return (ie.exp(H) + 1 / ie.exp(H)) / 2;
  }, U = function(H) {
    return ie.exp(H) - 1;
  }, $ = function(H) {
    return (ie.exp(2 * H) - 1) / (ie.exp(2 * H) + 1);
  }, se = function(H) {
    return ie.log(1 + H);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: t(1e308),
    acoshPf: v(1e154),
    asin: n(0.12312423423423424),
    asinh: r(1),
    asinhPf: E(1),
    atanh: o(0.5),
    atanhPf: w(0.5),
    atan: i(0.5),
    sin: a(-1e300),
    sinh: s(1),
    sinhPf: D(1),
    cos: l(10.000000000123),
    cosh: c(1),
    coshPf: B(1),
    tan: d(-1e300),
    tanh: f(1),
    tanhPf: $(1),
    exp: R(1),
    expm1: p(1),
    expm1Pf: U(1),
    log1p: h(10),
    log1pPf: se(10),
    powPI: g(-100)
  };
}
var Gc = "mmMwWLliI0fiflO&1", er = {
  /**
   * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
   * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
   */
  default: [],
  /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
  apple: [{ font: "-apple-system-body" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  serif: [{ fontFamily: "serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  sans: [{ fontFamily: "sans-serif" }],
  /** User can change it in desktop Chrome and desktop Firefox. */
  mono: [{ fontFamily: "monospace" }],
  /**
   * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
   * The height can be 0 in Chrome on a retina display.
   */
  min: [{ fontSize: "1px" }],
  /** Tells one OS from another in desktop Chrome. */
  system: [{ fontFamily: "system-ui" }]
};
function zc() {
  return Vc(function(e, t) {
    for (var n = {}, r = {}, o = 0, i = Object.keys(er); o < i.length; o++) {
      var a = i[o], s = er[a], l = s[0], c = l === void 0 ? {} : l, d = s[1], f = d === void 0 ? Gc : d, R = e.createElement("span");
      R.textContent = f, R.style.whiteSpace = "nowrap";
      for (var p = 0, h = Object.keys(c); p < h.length; p++) {
        var g = h[p], v = c[g];
        v !== void 0 && (R.style[g] = v);
      }
      n[a] = R, t.appendChild(e.createElement("br")), t.appendChild(R);
    }
    for (var E = 0, w = Object.keys(er); E < w.length; E++) {
      var a = w[E];
      r[a] = n[a].getBoundingClientRect().width;
    }
    return r;
  });
}
function Vc(e, t) {
  return t === void 0 && (t = 4e3), Po(function(n, r) {
    var o = r.document, i = o.body, a = i.style;
    a.width = "".concat(t, "px"), a.webkitTextSizeAdjust = a.textSizeAdjust = "none", Rr() ? i.style.zoom = "".concat(1 / r.devicePixelRatio) : pn() && (i.style.zoom = "reset");
    var s = o.createElement("div");
    return s.textContent = To([], Array(t / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), i.appendChild(s), e(o, i);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function qc() {
  return navigator.pdfViewerEnabled;
}
function Zc() {
  var e = new Float32Array(1), t = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], t[3];
}
function Yc() {
  var e = window.ApplePaySession;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return -1;
  try {
    return e.canMakePayments() ? 1 : 0;
  } catch (t) {
    return Xc(t);
  }
}
function Xc(e) {
  if (e instanceof Error) {
    if (e.name === "InvalidAccessError") {
      if (/\bfrom\b.*\binsecure\b/i.test(e.message))
        return -2;
      if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(e.message))
        return -3;
    }
    if (e.name === "SecurityError" && /\bthird.party iframes?.*\bnot.allowed\b/i.test(e.message))
      return -3;
  }
  throw e;
}
function Kc() {
  var e, t = document.createElement("a"), n = (e = t.attributionSourceId) !== null && e !== void 0 ? e : t.attributionsourceid;
  return n === void 0 ? void 0 : String(n);
}
var Bo = -1, jo = -2, Qc = /* @__PURE__ */ new Set([
  10752,
  2849,
  2884,
  2885,
  2886,
  2928,
  2929,
  2930,
  2931,
  2932,
  2960,
  2961,
  2962,
  2963,
  2964,
  2965,
  2966,
  2967,
  2968,
  2978,
  3024,
  3042,
  3088,
  3089,
  3106,
  3107,
  32773,
  32777,
  32777,
  32823,
  32824,
  32936,
  32937,
  32938,
  32939,
  32968,
  32969,
  32970,
  32971,
  3317,
  33170,
  3333,
  3379,
  3386,
  33901,
  33902,
  34016,
  34024,
  34076,
  3408,
  3410,
  3411,
  3412,
  3413,
  3414,
  3415,
  34467,
  34816,
  34817,
  34818,
  34819,
  34877,
  34921,
  34930,
  35660,
  35661,
  35724,
  35738,
  35739,
  36003,
  36004,
  36005,
  36347,
  36348,
  36349,
  37440,
  37441,
  37443,
  7936,
  7937,
  7938
  // SAMPLE_ALPHA_TO_COVERAGE (32926) and SAMPLE_COVERAGE (32928) are excluded because they trigger a console warning
  // in IE, Chrome ≤ 59 and Safari ≤ 13 and give no entropy.
]), _c = /* @__PURE__ */ new Set([
  34047,
  35723,
  36063,
  34852,
  34853,
  34854,
  34229,
  36392,
  36795,
  38449
  // MAX_VIEWS_OVR
]), $c = ["FRAGMENT_SHADER", "VERTEX_SHADER"], eu = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], Ho = "WEBGL_debug_renderer_info";
function tu(e) {
  var t, n, r, o, i, a, s = e.cache, l = Jo(s);
  if (!l)
    return Bo;
  if (!Fo(l))
    return jo;
  var c = xo() ? null : l.getExtension(Ho);
  return {
    version: ((t = l.getParameter(l.VERSION)) === null || t === void 0 ? void 0 : t.toString()) || "",
    vendor: ((n = l.getParameter(l.VENDOR)) === null || n === void 0 ? void 0 : n.toString()) || "",
    vendorUnmasked: c ? (r = l.getParameter(c.UNMASKED_VENDOR_WEBGL)) === null || r === void 0 ? void 0 : r.toString() : "",
    renderer: ((o = l.getParameter(l.RENDERER)) === null || o === void 0 ? void 0 : o.toString()) || "",
    rendererUnmasked: c ? (i = l.getParameter(c.UNMASKED_RENDERER_WEBGL)) === null || i === void 0 ? void 0 : i.toString() : "",
    shadingLanguageVersion: ((a = l.getParameter(l.SHADING_LANGUAGE_VERSION)) === null || a === void 0 ? void 0 : a.toString()) || ""
  };
}
function nu(e) {
  var t = e.cache, n = Jo(t);
  if (!n)
    return Bo;
  if (!Fo(n))
    return jo;
  var r = n.getSupportedExtensions(), o = n.getContextAttributes(), i = [], a = [], s = [], l = [];
  if (o)
    for (var c = 0, d = Object.keys(o); c < d.length; c++) {
      var f = d[c];
      i.push("".concat(f, "=").concat(o[f]));
    }
  for (var R = _r(n), p = 0, h = R; p < h.length; p++) {
    var g = h[p], v = n[g];
    a.push("".concat(g, "=").concat(v).concat(Qc.has(v) ? "=".concat(n.getParameter(v)) : ""));
  }
  if (r)
    for (var E = 0, w = r; E < w.length; E++) {
      var D = w[E];
      if (!(D === Ho && xo())) {
        var B = n.getExtension(D);
        if (B)
          for (var U = 0, $ = _r(B); U < $.length; U++) {
            var g = $[U], v = B[g];
            s.push("".concat(g, "=").concat(v).concat(_c.has(v) ? "=".concat(n.getParameter(v)) : ""));
          }
      }
    }
  for (var se = 0, H = $c; se < H.length; se++)
    for (var de = H[se], Y = 0, G = eu; Y < G.length; Y++) {
      var J = G[Y], te = ru(n, de, J);
      l.push("".concat(de, ".").concat(J, "=").concat(te.join(",")));
    }
  return s.sort(), a.sort(), {
    contextAttributes: i,
    parameters: a,
    shaderPrecisions: l,
    extensions: r,
    extensionParameters: s
  };
}
function Jo(e) {
  if (e.webgl)
    return e.webgl.context;
  var t = document.createElement("canvas"), n;
  t.addEventListener("webglCreateContextError", function() {
    return n = void 0;
  });
  for (var r = 0, o = ["webgl", "experimental-webgl"]; r < o.length; r++) {
    var i = o[r];
    try {
      n = t.getContext(i);
    } catch {
    }
    if (n)
      break;
  }
  return e.webgl = { context: n }, n;
}
function ru(e, t, n) {
  var r = e.getShaderPrecisionFormat(e[t], e[n]);
  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
}
function _r(e) {
  var t = Object.keys(e.__proto__);
  return t.filter(ou);
}
function ou(e) {
  return typeof e == "string" && !e.match(/[^A-Z0-9_x]/);
}
function xo() {
  return No();
}
function Fo(e) {
  return typeof e.getParameter == "function";
}
var iu = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.
  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: _s,
  domBlockers: Dc,
  fontPreferences: zc,
  audio: zs,
  screenFrame: mc,
  canvas: ec,
  osCpu: sc,
  languages: cc,
  colorDepth: uc,
  deviceMemory: lc,
  screenResolution: dc,
  hardwareConcurrency: Ec,
  timezone: Sc,
  sessionStorage: Rc,
  localStorage: Ic,
  indexedDB: yc,
  openDatabase: Ac,
  cpuClass: wc,
  platform: bc,
  plugins: $s,
  touchSupport: ac,
  vendor: Tc,
  vendorFlavors: Oc,
  cookiesEnabled: kc,
  colorGamut: Bc,
  invertedColors: jc,
  forcedColors: Hc,
  monochrome: xc,
  contrast: Fc,
  reducedMotion: Mc,
  hdr: Wc,
  math: Uc,
  pdfViewerEnabled: qc,
  architecture: Zc,
  applePay: Yc,
  privateClickMeasurement: Kc,
  // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
  // after other sources.
  webGlBasics: tu,
  webGlExtensions: nu
};
function au(e) {
  return Js(iu, e, []);
}
var su = "$ if upgrade to Pro: https://fpjs.dev/pro";
function cu(e) {
  var t = uu(e), n = lu(t);
  return { score: t, comment: su.replace(/\$/g, "".concat(n)) };
}
function uu(e) {
  if (Lo())
    return 0.4;
  if (pn())
    return Ir() ? 0.5 : 0.3;
  var t = "value" in e.platform ? e.platform.value : "";
  return /^Win/.test(t) ? 0.6 : /^Mac/.test(t) ? 0.5 : 0.7;
}
function lu(e) {
  return Co(0.99 + 0.01 * e, 1e-4);
}
function du(e) {
  for (var t = "", n = 0, r = Object.keys(e).sort(); n < r.length; n++) {
    var o = r[n], i = e[o], a = "error" in i ? "error" : JSON.stringify(i.value);
    t += "".concat(t ? "|" : "").concat(o.replace(/([:|\\])/g, "\\$1"), ":").concat(a);
  }
  return t;
}
function Mo(e) {
  return JSON.stringify(e, function(t, n) {
    return n instanceof Error ? Ns(n) : n;
  }, 2);
}
function Wo(e) {
  return Ds(du(e));
}
function fu(e) {
  var t, n = cu(e);
  return {
    get visitorId() {
      return t === void 0 && (t = Wo(this.components)), t;
    },
    set visitorId(r) {
      t = r;
    },
    confidence: n,
    components: e,
    version: Oo
  };
}
function pu(e) {
  return e === void 0 && (e = 50), Cs(e, e * 2);
}
function hu(e, t) {
  var n = Date.now();
  return {
    get: function(r) {
      return rt(this, void 0, void 0, function() {
        var o, i, a;
        return ot(this, function(s) {
          switch (s.label) {
            case 0:
              return o = Date.now(), [4, e()];
            case 1:
              return i = s.sent(), a = fu(i), (t || r != null && r.debug) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(a.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(o - n, `
visitorId: `).concat(a.visitorId, `
components: `).concat(Mo(i), "\n```")), [2, a];
          }
        });
      });
    }
  };
}
function gu() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(Oo, "/npm-monitoring"), !0), e.send();
    } catch (t) {
      console.error(t);
    }
}
function mu(e) {
  var t = e === void 0 ? {} : e, n = t.delayFallback, r = t.debug, o = t.monitoring, i = o === void 0 ? !0 : o;
  return rt(this, void 0, void 0, function() {
    var a;
    return ot(this, function(s) {
      switch (s.label) {
        case 0:
          return i && gu(), [4, pu(n)];
        case 1:
          return s.sent(), a = au({ cache: {}, debug: r }), [2, hu(a, r)];
      }
    });
  });
}
var Uo = { load: mu, hashComponents: Wo, componentsToDebugString: Mo };
var Mn = {}, Eu = xt && xt.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var o = Object.getOwnPropertyDescriptor(t, n);
  (!o || ("get" in o ? !t.__esModule : o.writable || o.configurable)) && (o = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, o);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Su = xt && xt.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), vu = xt && xt.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Eu(t, e, n);
  return Su(t, e), t;
};
Object.defineProperty(Mn, "__esModule", { value: !0 });
var Go = Mn.useTurnstile = void 0;
const jt = vu(re), sn = typeof globalThis < "u" ? globalThis : window;
let Tt = typeof sn.turnstile < "u" ? "ready" : "unloaded", zo, fr;
const Vo = new Promise((e, t) => {
  fr = { resolve: e, reject: t }, Tt === "ready" && e(void 0);
});
{
  const e = "cf__reactTurnstileOnLoad", t = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  zo = () => {
    if (Tt === "unloaded") {
      Tt = "loading", sn[e] = () => {
        fr.resolve(), Tt = "ready", delete sn[e];
      };
      const n = `${t}?onload=${e}&render=explicit`, r = document.createElement("script");
      r.src = n, r.async = !0, r.addEventListener("error", () => {
        fr.reject("Failed to load Turnstile."), delete sn[e];
      }), document.head.appendChild(r);
    }
    return Vo;
  };
}
function Ru({ id: e, className: t, style: n, sitekey: r, action: o, cData: i, theme: a, language: s, tabIndex: l, responseField: c, responseFieldName: d, size: f, fixedSize: R, retry: p, retryInterval: h, refreshExpired: g, appearance: v, execution: E, userRef: w, onVerify: D, onLoad: B, onError: U, onExpire: $, onTimeout: se, onAfterInteractive: H, onBeforeInteractive: de, onUnsupported: Y }) {
  const G = (0, jt.useRef)(null), J = (0, jt.useState)({
    onVerify: D,
    onLoad: B,
    onError: U,
    onExpire: $,
    onTimeout: se,
    onAfterInteractive: H,
    onBeforeInteractive: de,
    onUnsupported: Y
  })[0], te = w ?? G;
  return (0, jt.useEffect)(() => {
    if (!te.current)
      return;
    let N = !1, b = "";
    return (async () => {
      var I, O;
      if (Tt !== "ready")
        try {
          await zo();
        } catch (P) {
          (I = J.onError) === null || I === void 0 || I.call(J, P);
          return;
        }
      if (N || !te.current)
        return;
      let A;
      const x = {
        sitekey: r,
        action: o,
        cData: i,
        theme: a,
        language: s,
        tabindex: l,
        "response-field": c,
        "response-field-name": d,
        size: f,
        retry: p,
        "retry-interval": h,
        "refresh-expired": g,
        appearance: v,
        execution: E,
        callback: (P) => {
          var M;
          return (M = J.onVerify) === null || M === void 0 ? void 0 : M.call(J, P, A);
        },
        "error-callback": (P) => {
          var M;
          return (M = J.onError) === null || M === void 0 ? void 0 : M.call(J, P, A);
        },
        "expired-callback": (P) => {
          var M;
          return (M = J.onExpire) === null || M === void 0 ? void 0 : M.call(J, P, A);
        },
        "timeout-callback": () => {
          var P;
          return (P = J.onTimeout) === null || P === void 0 ? void 0 : P.call(J, A);
        },
        "after-interactive-callback": () => {
          var P;
          return (P = J.onAfterInteractive) === null || P === void 0 ? void 0 : P.call(J, A);
        },
        "before-interactive-callback": () => {
          var P;
          return (P = J.onBeforeInteractive) === null || P === void 0 ? void 0 : P.call(J, A);
        },
        "unsupported-callback": () => {
          var P;
          return (P = J.onUnsupported) === null || P === void 0 ? void 0 : P.call(J, A);
        }
      };
      b = window.turnstile.render(te.current, x), A = yu(b), (O = J.onLoad) === null || O === void 0 || O.call(J, b, A);
    })(), () => {
      N = !0, b && window.turnstile.remove(b);
    };
  }, [
    r,
    o,
    i,
    a,
    s,
    l,
    c,
    d,
    f,
    p,
    h,
    g,
    v,
    E
  ]), (0, jt.useEffect)(() => {
    J.onVerify = D, J.onLoad = B, J.onError = U, J.onExpire = $, J.onTimeout = se, J.onAfterInteractive = H, J.onBeforeInteractive = de, J.onUnsupported = Y;
  }, [
    D,
    B,
    U,
    $,
    se,
    H,
    de,
    Y
  ]), jt.default.createElement("div", { ref: te, id: e, className: t, style: R ? {
    ...n ?? {},
    width: f === "compact" ? "130px" : "300px",
    height: f === "compact" ? "120px" : "65px"
  } : n });
}
var Iu = Mn.default = Ru;
function yu(e) {
  return {
    execute: (t) => window.turnstile.execute(e, t),
    reset: () => window.turnstile.reset(e),
    getResponse: () => window.turnstile.getResponse(e),
    isExpired: () => window.turnstile.isExpired(e)
  };
}
function Au() {
  const [e, t] = (0, jt.useState)(Tt);
  return (0, jt.useEffect)(() => {
    Tt !== "ready" && Vo.then(() => t(Tt));
  }, []), sn.turnstile;
}
Go = Mn.useTurnstile = Au;
const $u = (e) => {
  const t = Uo.load(), [n, r] = gt(""), [o, i] = gt(""), a = _e(null), s = _e(null), l = $r();
  Go(), re.useEffect(() => {
    c();
  }, []);
  const c = () => {
    if (!n || n.length === 0) {
      const g = document.getElementById("phoneTabs");
      g && g.click();
    }
  }, d = (g, v) => {
    r(v);
    let E;
    const w = document.querySelectorAll(`.${we.tabcontent}`);
    for (E = 0; E < w.length; E++)
      w[E].style.display = "none";
    const D = document.querySelectorAll(`.${we.tablinks}`);
    for (E = 0; E < D.length; E++)
      D[E].className = D[E].className.replace(" active", "");
    const B = document.getElementById(v);
    B && (B.style.display = "block"), g.currentTarget.className += " active";
  }, f = (g) => {
    if (g.preventDefault(), !a.current || a.current.value.length === 0) {
      debugger;
      q("请输入用户名!");
      return;
    }
    if (!s.current || s.current.value.length === 0) {
      q("请输入密码!");
      return;
    }
    let v = {
      phone: a.current.value,
      password: s.current.value
    };
    (async () => {
      const w = await (await t).get();
      let D = {
        ...v,
        deviceId: w.visitorId,
        deviceName: w.visitorId,
        deviceType: 4,
        appId: e.appId,
        loginType: 1,
        cfToken: o
      };
      Jt.userLoginByPhoneImpl(
        D,
        e.store,
        e.loginUrl
      ).then((B) => {
        Ot.responseSuccess(B) ? l("/") : q.error(B.msg);
      });
    })();
  }, R = () => {
    let g = {
      appId: e.appId
    };
    Jt.userLoginImpl(
      g,
      e.store,
      "/infra/alipay/login/getQRCodeUrl"
    ).then((v) => {
      window.location.href = v.result;
    });
  }, p = () => {
    let g = {
      appId: e.appId
    };
    Jt.userLoginImpl(
      g,
      e.store,
      "/infra/wechat/login/getQRCodeUrl"
    ).then((v) => {
      window.location.href = v.result;
    });
  }, h = () => {
    if (e.enableWechatLogin)
      return /* @__PURE__ */ T.jsx(
        "button",
        {
          className: we.tablinks,
          onClick: (g) => {
            p();
          },
          children: "微信扫码登录"
        }
      );
  };
  return /* @__PURE__ */ T.jsxs("div", { className: we.loginContainer, children: [
    /* @__PURE__ */ T.jsxs("div", { className: we.loginForm, children: [
      /* @__PURE__ */ T.jsxs("div", { className: we.loginTabs, children: [
        /* @__PURE__ */ T.jsx(
          "button",
          {
            id: "phoneTabs",
            className: we.tablinks,
            onClick: (g) => {
              d(g, "phone");
            },
            children: "手机号登录"
          }
        ),
        h(),
        /* @__PURE__ */ T.jsx(
          "button",
          {
            className: we.tablinks,
            onClick: (g) => {
              R();
            },
            children: "支付宝扫码登录"
          }
        )
      ] }),
      /* @__PURE__ */ T.jsxs("div", { id: "phone", className: we.tabcontent, children: [
        /* @__PURE__ */ T.jsx("h5", { children: "登录" }),
        /* @__PURE__ */ T.jsxs(
          "form",
          {
            method: "post",
            className: we.loginElement,
            onSubmit: (g) => f(g),
            children: [
              /* @__PURE__ */ T.jsxs("div", { className: we.userName, children: [
                /* @__PURE__ */ T.jsxs("select", { id: "countryCode", className: we.countryCodeSelect, children: [
                  /* @__PURE__ */ T.jsx("option", { value: "+86", children: "+86" }),
                  /* @__PURE__ */ T.jsx("option", { value: "+1", children: "+1" })
                ] }),
                /* @__PURE__ */ T.jsx(
                  "input",
                  {
                    type: "text",
                    ref: a,
                    id: "phone",
                    placeholder: "请输入手机号码"
                  }
                )
              ] }),
              /* @__PURE__ */ T.jsx("div", { className: we.password, children: /* @__PURE__ */ T.jsx(
                "input",
                {
                  type: "password",
                  ref: s,
                  placeholder: "密码",
                  name: "p"
                }
              ) }),
              /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(
                Iu,
                {
                  className: we.turnstile,
                  sitekey: e.cfSiteKey,
                  onVerify: (g) => {
                    i(g);
                  }
                }
              ) }),
              /* @__PURE__ */ T.jsx("div", { className: we.operate, children: /* @__PURE__ */ T.jsx("button", { className: we.loginButton, type: "submit", children: "登录" }) }),
              /* @__PURE__ */ T.jsxs("div", { className: we.handleSituation, children: [
                /* @__PURE__ */ T.jsx("a", { href: "/user/reg", children: "没有账号，去注册" }),
                /* @__PURE__ */ T.jsx("a", { href: "/userpage/pwd/retrieve", children: "忘记密码？" })
              ] })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ T.jsx("div", { id: "wechat", className: we.tabcontent }),
      /* @__PURE__ */ T.jsx("div", { id: "alipay", className: we.tabcontent })
    ] }),
    /* @__PURE__ */ T.jsx(Cn, {})
  ] });
}, wu = "_regContainer_guiwi_1", bu = "_regForm_guiwi_9", Tu = "_countryCodeSelect_guiwi_16", Ou = "_loginTabs_guiwi_20", ku = "_active_guiwi_42", Cu = "_tabcontent_guiwi_46", Du = "_loginElement_guiwi_55", Nu = "_userName_guiwi_62", Lu = "_password_guiwi_68", Pu = "_countryCode_guiwi_16", Bu = "_loginButton_guiwi_116", ju = "_operate_guiwi_129", ft = {
  regContainer: wu,
  regForm: bu,
  countryCodeSelect: Tu,
  loginTabs: Ou,
  active: ku,
  tabcontent: Cu,
  loginElement: Du,
  userName: Nu,
  password: Lu,
  countryCode: Pu,
  loginButton: Bu,
  operate: ju
}, el = (e) => {
  const t = Uo.load(), n = _e(null), r = _e(null), o = _e(null), i = $r(), a = (s) => {
    if (s.preventDefault(), !n.current || n.current.value.length === 0) {
      debugger;
      q("请输入用户名!");
      return;
    }
    if (!r.current || r.current.value.length === 0) {
      q("请输入密码!");
      return;
    }
    let l = r.current.value;
    if (!/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[`~!@#$%^&*()-=_+;':",./<>?])(?=\S+$).{6,32}$/.test(l)) {
      q("密码必须包含字母、数字和特殊符号且长度是6-32位!");
      return;
    }
    if (!o.current || o.current.value.length === 0) {
      q("请输入密码!");
      return;
    }
    let f = o.current.value;
    if (l != f) {
      q("输入密码不一致!");
      return;
    }
    let R = {
      phone: n.current.value,
      password: l
    };
    (async () => {
      const h = await (await t).get();
      let g = {
        ...R,
        deviceId: h.visitorId,
        deviceName: h.visitorId,
        deviceType: 4,
        appId: e.appId,
        loginType: 1
      };
      Jt.userReg(g, e.store, e.regUrl).then((v) => {
        Ot.responseSuccess(v) ? (q.success("注册成功"), i("/user/login")) : q.error(v.msg);
      });
    })();
  };
  return /* @__PURE__ */ T.jsxs("div", { className: ft.regContainer, children: [
    /* @__PURE__ */ T.jsx("div", { className: ft.regForm, children: /* @__PURE__ */ T.jsxs("form", { method: "post", className: ft.loginElement, onSubmit: (s) => a(s), children: [
      /* @__PURE__ */ T.jsx("h5", { children: "注册" }),
      /* @__PURE__ */ T.jsxs("div", { className: ft.userName, children: [
        /* @__PURE__ */ T.jsxs("select", { id: "countryCode", className: ft.countryCodeSelect, children: [
          /* @__PURE__ */ T.jsx("option", { value: "+86", children: "+86" }),
          /* @__PURE__ */ T.jsx("option", { value: "+1", children: "+1" })
        ] }),
        /* @__PURE__ */ T.jsx("input", { type: "text", ref: n, id: "phone", placeholder: "请输入手机号码" })
      ] }),
      /* @__PURE__ */ T.jsx("div", { className: ft.password, children: /* @__PURE__ */ T.jsx("input", { type: "password", ref: r, placeholder: "密码", name: "p" }) }),
      /* @__PURE__ */ T.jsx("div", { className: ft.password, children: /* @__PURE__ */ T.jsx("input", { type: "password", ref: o, placeholder: "再次输入密码", name: "p" }) }),
      /* @__PURE__ */ T.jsxs("div", { className: ft.operate, children: [
        /* @__PURE__ */ T.jsx("button", { className: ft.loginButton, type: "submit", children: "注册" }),
        /* @__PURE__ */ T.jsx("a", { href: "/user/login", children: "已经有账号，去登录" })
      ] })
    ] }) }),
    /* @__PURE__ */ T.jsx(Cn, {})
  ] });
}, tl = {
  0: "待支付",
  1: "已支付",
  2: "已发货"
};
export {
  Mu as CommonPage,
  qu as CommonPageCon,
  Vu as CommonPageFunction,
  Bt as FileActionType,
  Qu as FileService,
  Zu as Footer,
  Gu as Goods,
  Xu as MessageHandler,
  Ka as OrderService,
  Xa as Pay,
  Lt as PayActionType,
  Mr as PayService,
  Ku as PaySuccess,
  $u as RdLogin,
  el as RdReg,
  Wr as SseClientService,
  Le as UserActionType,
  Yu as UserProfile,
  Jt as UserService,
  me as XHRClient,
  _u as countryCodes,
  Ja as doGetIapProduct,
  tl as orderStatus,
  zu as rdRootReducer,
  Ya as withConnect
};
//# sourceMappingURL=rd-component.es.js.map
